import React, { createContext, useContext, useState, useEffect, useCallback } from "react";

export const LANGUAGES = [
  { code: "en", label: "English", flag: "🇬🇧" },
  { code: "fr", label: "Français", flag: "🇫🇷" },
  { code: "es", label: "Español", flag: "🇪🇸" },
  { code: "de", label: "Deutsch", flag: "🇩🇪" },
  { code: "it", label: "Italiano", flag: "🇮🇹" },
  { code: "pt", label: "Português", flag: "🇵🇹" },
  { code: "ru", label: "Русский", flag: "🇷🇺" },
  { code: "ar", label: "العربية", flag: "🇸🇦" },
  { code: "zh", label: "中文", flag: "🇨🇳" },
  { code: "ja", label: "日本語", flag: "🇯🇵" },
];

export const RTL_LANGS = ["ar"];

// English is the base / fallback. Missing keys fall back to English then to the key.
const en = {
  dev_rename: "Rename",
  dev_rename_ph: "Device name",
  push_blocks: "Planning block alarms",
  pv_pomodoro: "Pomodoro",
  pv_pomodoro_done: "Pomodoro added: 25 min focus / 5 min break",
  pv_sound: "Alarm sound",
  pv_test: "Test",
  snd_chime: "Chime",
  snd_bell: "Bell",
  snd_beep: "Beep",
  snd_soft: "Soft",
  banner_text: "Add GaimTime to your home screen",
  banner_btn: "Install",
  ia_and_title: "On Android (Chrome)",
  ia_and_1: "Open Chrome's menu ⋮ (top right).",
  ia_and_2: "Tap 'Install and create a shortcut'.",
  ia_and_3: "Tap 'Install' — done!",
  install_app: "Install the app",
  ia_title: "Install GaimTime on your phone",
  ia_desc: "Add GaimTime to your home screen: quick access, full screen, like a real app.",
  ia_install_btn: "Install now",
  ia_installed: "GaimTime is already installed on this device 🎉",
  ia_ios_title: "On iPhone / iPad (Safari)",
  ia_ios_1: "Tap the Share button at the bottom of Safari.",
  ia_ios_2: "Choose 'Add to Home Screen'.",
  ia_ios_3: "Tap 'Add' — done!",
  ia_soon: "Screenshot coming soon",
  pv_add: "Add a block",
  pv_label: "Name",
  pv_type: "Type",
  pv_task: "Task",
  pv_break: "Break",
  pv_start: "Start",
  pv_end: "End",
  pv_alarm_start: "Alarm at start",
  pv_alarm_end: "Alarm at end",
  pv_free: "Free",
  pv_save: "Add",
  pv_cancel: "Cancel",
  pv_delete: "Delete",
  pv_invalid: "End must be after start, within your day.",
  pv_none: "No block yet. Your day is free — add your first block!",
  pv_fired: "Time's up",
  pv_stop: "Stop",
  lifetime_badge: "Lifetime",
  daystart_title: "Your GaimTime day begins! ⏳",
  daystart_body: "Time to gain — your compressed day just started.",
  chpwd_menu: "Change password",
  chpwd_title: "Change password",
  chpwd_current: "Current password",
  chpwd_new: "New password",
  chpwd_confirm: "Confirm new password",
  chpwd_save: "Save",
  chpwd_success: "Password changed successfully",
  chpwd_err_current: "Current password is incorrect",
  chpwd_err_short: "Password too short (min 6 characters)",
  chpwd_err_match: "Passwords do not match",
  chpwd_err_same: "New password must be different",
  pv_reset: "Clear all",
  menu_account: "My account",
  menu_notif: "Notifications",
  menu_help: "Guide / Help",
  state_on: "On",
  state_off: "Off",
  ob_next: "Next",
  ob_back: "Back",
  ob_skip: "Skip",
  ob_done: "Got it!",
  ob_t1: "Welcome to GaimTime 👋",
  ob_d1: "A quick tour to get the most out of your time. It takes 20 seconds.",
  ob_t2: "Your two clocks",
  ob_d2: "On the left, the real time. On the right, your accelerated GaimTime. The gap is the time you gain.",
  ob_t3: "Set up your day",
  ob_d3: "Pick your gain goal and start time. 'Open Planning (24h)' organizes your time blocks.",
  ob_t4: "Your account menu",
  ob_d4: "Top right: notifications, AI Coach setup, clock in notifications, my devices, invoices and help — all in one place.",
  ob_t5: "Your AI Coach",
  ob_d5: "Chat with your Coach & Companion anytime — it motivates you like a close friend.",
  lc_title: "Clock in notifications",
  lc_on: "GaimTime clock enabled in your notifications",
  lc_off: "Notification clock disabled",
  lc_denied: "Allow notifications to show the clock",
  lc_unsupported: "Your device doesn't support this",
  lc_gaim: "GaimTime",
  lc_gain: "Gain",
  devices_title: "My devices",
  devices_desc: "You can use up to 2 devices. Disconnect one to free a slot.",
  dev_this_device: "This device",
  devices_empty: "No active device.",
  dev_limit_title: "Too many devices",
  dev_limit_desc: "You've reached the limit of 2 devices. Disconnect one to continue on this device.",
  dev_disconnect: "Disconnect",
  dev_seen: "Active",
  hiw_audio_error: "Audio unavailable right now. Please try again in a moment.",
  upgrade_super_btn: "Upgrade to Super AI", plan_standard: "Standard Coach", plan_standard_desc: "Fast, natural AI assistant", plan_super: "Super AI", plan_super_desc: "The smartest AI, more daily messages & voice", plan_super_tag: "Best", activate_super: "Activate Super AI", ps_success_super: "Super AI activated!", tts_limit_reached: "Daily voice playback limit reached.",
  my_invoices: "My invoices",
  download: "Download",
  no_invoices: "No invoice yet.",
  ctx_desc_general: "Free chat: talk about whatever you want, your coach is here for you.",
  ctx_desc_work: "Work mode: focus and efficiency — your coach helps you move forward.",
  ctx_desc_company: "Just company: we chat, we laugh, you feel heard.",
  ctx_desc_advice: "Need advice or help to decide? Lay out your situation.",
  ctx_desc_relax: "Chill time: unwind and take your mind off things.",
  ctx_desc_seduction: "Seduction, flirting and intimacy: playful and sensual vibe (never explicit).",
  clear_thread: "Clear conversation",
  clear_thread_q: "Clear this whole conversation?",
  clear_thread_desc: "This only erases the messages of this topic. Your saved context note stays.",
  thread_cleared: "Conversation cleared",
  clear_confirm: "Clear",
  note_btn: "Context note",
  note_title: "Topic context (remembered by the AI)",
  note_ph: "Describe the topic, your situation, what the AI should always remember…",
  note_hint: "Kept in memory even if you clear the conversation. Not counted in your messages.",
  note_saved: "Context saved",
  mic_hint: "Speak",
  mic_listening: "Listening… tap to stop",
  mic_unsupported: "Voice input isn't supported on this browser",
  notif_settings: "Notification settings",
  notif_settings_desc: "Choose which push notifications you receive.",
  push_morning: "Morning boost",
  push_midday: "Midday check-in",
  push_coach: "Coach idea (AI)",
  push_evening: "Evening recap",
  push_night: "Tomorrow prep",
  push_reengage: "We miss you",
  push_coach_note: "Requires the Coach subscription.",
  notif_prefs_saved: "Preferences saved",
  intent_label: "What do you need today?",
  intent_none: "General",
  intent_work: "Serious work",
  intent_company: "Company",
  intent_advice: "Advice",
  intent_relax: "Unwind",
  intent_seduction: "Seduction",
  intent_saved: "Got it — I'll adapt to your day 👍",
  nav_login: "Sign in", nav_cta: "Activate for life", nav_logout: "Log out", nav_dashboard: "Dashboard", nav_admin: "Admin",
  hero_badge: "100% automated · Positive psychology",
  hero_t1: "GaimTime: Create your Personal Time,", hero_hl: "live by your own rules.", preview_explain: "Your GaimTime clock runs faster → you finish your day earlier and gain Personal Time.",
  hero_sub: "Stop letting time slip away. Whether you work, study or organize your days, gain up to 20 minutes per hour and free up time for what truly matters.",
  hero_cta: "Activate for life", hero_cta_sub: "· €4.99",
  hero_trust: "One-time payment · No hidden subscription · Secured by Stripe",
  today_gain: "Today · Gain 10 min/h",
  f1_t: "Two synced clocks", f1_d: "Your real time and your accelerated GaimTime, updated second by second.",
  f2_t: "Live cumulative gain", f2_d: "See the time you recover: up to 1h20 over an 8h day.",
  f3_t: "24h compressed planning", f3_d: "Project your tasks into a compressed day and reach your goals earlier.",
  comp_badge: "GaimTime Coach & Companion", comp_t: "An AI coach & companion who truly knows you.",
  comp_d: "Not a mere chatbot. An intimate, honest friend who listens, advises and pushes you to act. Love, doubts, projects, fears — it's there, unfiltered.",
  comp_avail: "Available via the Coach & Companion subscription (€9.99/mo) from your Dashboard.",
  chat_demo_q: "I have a big decision to make tomorrow…", chat_demo_a: "Okay, breathe. Tell me everything, we'll figure it out together. What's really blocking you?",
  pricing_t: "One payment. Lifetime access.", pricing_sub: "No hidden subscription for the app. The AI Companion stays optional.",
  price_life: "/ lifetime", pf1: "Full dashboard & GaimTime clocks", pf2: "24h compressed planning", pf3: "Save up to 20 min/hour", pf4: "Lifetime updates",
  pricing_cta: "Activate for life",
  footer_contact: "Contact", footer_cgv: "Terms", footer_legal: "Legal notice",
  contact_title: "Contact us", contact_desc: "A question? Write to us at this address:", contact_copy_or: "Or open your email app →", copied: "Email copied!",
  gain: "Gain", objective_t: "Gain objective", objective_d: "Choose the minutes you want to gain each hour", minh: "min/h", start: "Start",
  real_clock: "Real time", gaim_clock: "GaimTime hour", conv: "1h GaimTime = {n} real min",
  gain_cumule: "Cumulative gain", day8: "Day (8h)", reset_counters: "Reset counters",
  traj_t: "Gain trajectory (minutes / work hour)", open_planning: "Open Planning (24h)", hide_planning: "Hide Planning",
  coach_btn: "Chat with my Coach & Companion", timezone: "Time zone",
  planning_t: "Compressed planning", add_task: "Add a task…", reset: "Reset", now: "now", real: "real",
  coach_title: "GaimTime Coach & Companion", coach_empty: "Hey! I'm here for you. Tell me what's on your mind today. 👋", coach_ph: "Write to your coach…",
  create_acc: "Create account", sign_in: "Sign in", firstname: "First name", lastname: "Last name", email: "Email", password: "Password", company: "Company (optional)",
  comp_intro: "Get to know your Coach & Companion", comp_intro_sub: "Optional — for an AI coach who truly knows you.",
  situation_ph: "Your life situation (work, family…)", goals_ph: "Your current goals", interests_ph: "Your interests",
  login_submit: "Sign in", secure_pay: "Secure payment via Stripe",
  coachdlg_desc: "Unlock your AI life coach & companion: an intimate, honest friend, available 24/7.", permonth: "/ month", activate_coach: "Activate Coach & Companion — €9.99/mo",
  ps_checking: "Verifying your payment…", ps_wait_t: "One moment…", ps_success_life: "Lifetime access activated!", ps_success_coach: "Coach & Companion activated!",
  ps_done: "Done!", ps_oops: "Oops", ps_go_dash: "Go to Dashboard", ps_notfound: "Payment session not found.", ps_slow: "Payment is taking longer than expected. Check your Dashboard shortly.",
  lang_label: "Language", notif_on: "Notifications enabled 🔔", notif_off: "Notifications disabled", tz_saved: "Time zone saved",
  hiw_open: "How does it work?",
  hiw_title: "What if your day ended earlier?",
  hiw_intro: "GaimTime speeds up your clock. You move faster than real time, so your brain aims for an earlier end of day — and you finish ahead.",
  hiw_s1_t: "Choose your gain", hiw_s1_d: "Pick how many minutes to gain per hour: 5, 10, 15 or 20 min.",
  hiw_s2_t: "Your GaimTime clock speeds up", hiw_s2_d: "While real time moves normally, your GaimTime clock races ahead, second by second.",
  hiw_s3_t: "You finish earlier", hiw_s3_d: "When your GaimTime clock shows 5pm, it's actually only 4:10pm. You've gained 50 minutes.",
  hiw_s4_t: "Plan your tasks with alerts", hiw_s4_d: "Schedule your tasks in GaimTime hours and get a ringtone alert for each step.",
  hiw_example: "Example: at +10 min/hour, over an 8h day your GaimTime day \"ends\" while you still have 1h20 of real time left. That head start keeps you focused.",
  hiw_read: "Read", hiw_listen: "Listen", hiw_loading: "Generating voice…", hiw_playing: "Playing…",
  offer_clear_t: "One clear offer. Zero surprise.", offer_clear_sub: "Your lifetime access gives you all the essentials. The Coach is a nice extra, whenever you want it.",
  card1_tag: "Lifetime access · one-time payment", card2_tag: "Premium option", card2_optional: "(optional)",
  card2_title: "GaimTime Coach", card2_price: "€9.99", card2_feat: "Unlimited personal coach", card2_feat2: "Motivation, decisions, reframing", card2_note: "Activatable from your space once logged in",
  pricing_reassure: "GaimTime works 100% without the Coach. The Coach is an option, never mandatory.",
  listen_msg: "Listen",
  faq_title: "Frequently asked questions",
  faq_q1: "Does time really speed up?", faq_a1: "No 🙂 It's a psychology principle: your displayed GaimTime clock runs faster, which pushes your brain to finish earlier. Real time doesn't change.",
  faq_q2: "Do I pay only once?", faq_a2: "Yes, €4.99 for life, a single payment. The AI Coach is a separate option (€9.99/mo), never mandatory.",
  faq_q3: "What is the GaimTime Coach?", faq_a3: "A personal AI coach that motivates you and helps with your decisions. Optional, activatable from your space.",
  faq_q4: "Does it work on mobile / offline?", faq_a4: "Yes, GaimTime is an installable app (PWA) on your phone, with offline access.",
  faq_q5: "Is my data private?", faq_a5: "Yes, your data stays private and secure; payment is handled by Stripe.",
  faq_q6: "Can I cancel the Coach subscription?", faq_a6: "Yes, anytime. Your GaimTime lifetime access stays yours.",
  demo_title: "See the time you gain", demo_sub: "The more minutes you gain per hour, the earlier your day ends.", demo_classic: "Classic day", demo_withgaim: "With GaimTime", demo_saved: "{v} gained 🎉",
  forgot_pw: "Forgot password?", forgot_title: "Reset your password", forgot_desc: "Enter your email and we'll send you a link to choose a new password.", forgot_submit: "Send the link", forgot_sent: "If an account exists for this email, a reset link has just been sent.", back_to_login: "← Back to sign in",
  reset_title: "New password", reset_desc: "Choose a new password for your account.", reset_new_pw: "New password", reset_confirm_pw: "Confirm password", reset_submit: "Update password", reset_success: "Password updated! You can sign in now.", reset_mismatch: "Passwords don't match.", reset_invalid_link: "Invalid or expired link. Please request a new one.", reset_short: "Password must be at least 6 characters.",
  edit_profile: "Edit my profile", profile_title: "My profile", profile_saved: "Profile updated", save: "Save", cancel: "Cancel",
  coach_cfg_btn: "Configure my Coach", coach_cfg_title: "Set up your Coach & Companion", coach_cfg_desc: "All optional — shape a coach that truly fits you. Change it anytime, for work, life or anything else.",
  cfg_gender: "Coach gender", cfg_gender_m: "Male", cfg_gender_f: "Female",
  cfg_type: "Coach focus", type_work: "Work", type_life: "Life", type_love: "Love & dating", type_intimate: "Intimacy", type_company: "Companionship", type_other: "Other",
  cfg_tone: "Tone", tone_direct: "Direct & honest", tone_soft: "Gentle & caring", tone_motiv: "Motivating",
  cfg_nickname: "What should the coach call you?", cfg_challenges: "Your current challenges or blocks", cfg_values: "What matters most to you", cfg_motivation: "What motivates you",
  support_btn: "Support", tickets_title: "Support & Chat", tickets_desc: "A question? Write to us — we reply right here.", ticket_new: "New message", ticket_subject: "Subject", ticket_message: "Your message", ticket_send: "Send", ticket_reply_ph: "Write your reply…", ticket_empty: "No conversation yet.", ticket_open: "Open", ticket_closed: "Closed", ticket_sent: "Message sent!", ticket_back: "← Back", ticket_you: "You", ticket_team: "GaimTime Team", coach_daily_left: "messages left today",
  coach_limit_title: "You've hit 150 messages today 👏", coach_limit_desc: "Come back tomorrow… or keep going right now with a pack.", coach_buy_pack: "Continue · +150 messages · €2", coach_bonus_label: "bonus",
  err_generic: "Something went wrong. Please try again.",
};

const fr = {
  dev_rename: "Renommer",
  dev_rename_ph: "Nom de l'appareil",
  push_blocks: "Alarmes des blocs du planning",
  pv_pomodoro: "Pomodoro",
  pv_pomodoro_done: "Pomodoro ajouté : 25 min focus / 5 min pause",
  pv_sound: "Sonnerie",
  pv_test: "Tester",
  snd_chime: "Carillon",
  snd_bell: "Cloche",
  snd_beep: "Bip",
  snd_soft: "Doux",
  banner_text: "Ajoute GaimTime à ton écran d'accueil",
  banner_btn: "Installer",
  ia_and_title: "Sur Android (Chrome)",
  ia_and_1: "Ouvre le menu ⋮ de Chrome (en haut à droite).",
  ia_and_2: "Appuie sur « Installer et créer un raccourci ».",
  ia_and_3: "Appuie sur « Installer » — c'est fait !",
  install_app: "Installer l'app",
  ia_title: "Installer GaimTime sur ton téléphone",
  ia_desc: "Ajoute GaimTime à ton écran d'accueil : accès rapide, plein écran, comme une vraie application.",
  ia_install_btn: "Installer maintenant",
  ia_installed: "GaimTime est déjà installée sur cet appareil 🎉",
  ia_ios_title: "Sur iPhone / iPad (Safari)",
  ia_ios_1: "Appuie sur le bouton Partager en bas de Safari.",
  ia_ios_2: "Choisis « Sur l'écran d'accueil ».",
  ia_ios_3: "Appuie sur « Ajouter » — c'est fait !",
  ia_soon: "Capture à venir",
  pv_add: "Ajouter un bloc",
  pv_label: "Nom",
  pv_type: "Type",
  pv_task: "Tâche",
  pv_break: "Pause",
  pv_start: "Début",
  pv_end: "Fin",
  pv_alarm_start: "Alarme au début",
  pv_alarm_end: "Alarme à la fin",
  pv_free: "Libre",
  pv_save: "Ajouter",
  pv_cancel: "Annuler",
  pv_delete: "Supprimer",
  pv_invalid: "La fin doit être après le début, dans ta journée.",
  pv_none: "Aucun bloc pour l'instant. Ta journée est libre — ajoute ton premier bloc !",
  pv_fired: "C'est l'heure",
  pv_stop: "Arrêter",
  lifetime_badge: "À vie",
  daystart_title: "Ta journée GaimTime commence ! ⏳",
  daystart_body: "C'est parti — ta journée compressée a démarré.",
  chpwd_menu: "Changer mon mot de passe",
  chpwd_title: "Changer mon mot de passe",
  chpwd_current: "Mot de passe actuel",
  chpwd_new: "Nouveau mot de passe",
  chpwd_confirm: "Confirmer le nouveau mot de passe",
  chpwd_save: "Enregistrer",
  chpwd_success: "Mot de passe modifié avec succès",
  chpwd_err_current: "Mot de passe actuel incorrect",
  chpwd_err_short: "Mot de passe trop court (min 6 caractères)",
  chpwd_err_match: "Les mots de passe ne correspondent pas",
  chpwd_err_same: "Le nouveau mot de passe doit être différent",
  pv_reset: "Tout effacer",
  menu_account: "Mon compte",
  menu_notif: "Notifications",
  menu_help: "Guide / Aide",
  state_on: "Activé",
  state_off: "Désactivé",
  ob_next: "Suivant",
  ob_back: "Retour",
  ob_skip: "Passer",
  ob_done: "C'est compris !",
  ob_t1: "Bienvenue sur GaimTime 👋",
  ob_d1: "Une visite rapide pour profiter au mieux de ton temps. Ça prend 20 secondes.",
  ob_t2: "Tes deux horloges",
  ob_d2: "À gauche, l'heure réelle. À droite, ton Heure GaimTime accélérée. L'écart, c'est le temps que tu gagnes.",
  ob_t3: "Règle ta journée",
  ob_d3: "Choisis ton objectif de gain et ton heure de départ. « Ouvrir le Planning (24h) » organise tes blocs de temps.",
  ob_t4: "Ton menu compte",
  ob_d4: "En haut à droite : notifications, configuration du Coach IA, horloge en notification, mes appareils, factures et aide — tout au même endroit.",
  ob_t5: "Ton Coach IA",
  ob_d5: "Discute avec ton Coach & Compagnon quand tu veux — il te motive comme un ami proche.",
  lc_title: "Horloge dans les notifications",
  lc_on: "Horloge GaimTime activée dans tes notifications",
  lc_off: "Horloge des notifications désactivée",
  lc_denied: "Autorise les notifications pour afficher l'horloge",
  lc_unsupported: "Ton appareil ne supporte pas cette fonction",
  lc_gaim: "GaimTime",
  lc_gain: "Gain",
  devices_title: "Mes appareils",
  devices_desc: "Tu peux utiliser jusqu'à 2 appareils. Déconnecte-en un pour libérer une place.",
  dev_this_device: "Cet appareil",
  devices_empty: "Aucun appareil actif.",
  dev_limit_title: "Trop d'appareils connectés",
  dev_limit_desc: "Tu as atteint la limite de 2 appareils. Déconnecte un appareil pour continuer sur celui-ci.",
  dev_disconnect: "Déconnecter",
  dev_seen: "Actif",
  hiw_audio_error: "Audio indisponible pour le moment. Réessaie dans un instant.",
  upgrade_super_btn: "Passer à Super IA", plan_standard: "Coach Standard", plan_standard_desc: "L'assistant IA rapide et naturel", plan_super: "Super IA", plan_super_desc: "L'IA la plus intelligente, plus de messages et de voix par jour", plan_super_tag: "Le meilleur", activate_super: "Activer Super IA", ps_success_super: "Super IA activé !", tts_limit_reached: "Limite de lecture vocale du jour atteinte.",
  my_invoices: "Mes factures",
  download: "Télécharger",
  no_invoices: "Aucune facture pour l'instant.",
  ctx_desc_general: "Discussion libre : parle de ce que tu veux, ton coach est là pour toi.",
  ctx_desc_work: "Mode travail : concentration et efficacité — ton coach t'aide à avancer.",
  ctx_desc_company: "Juste de la compagnie : on discute, on rigole, tu es écouté.",
  ctx_desc_advice: "Besoin d'un conseil ou d'aide pour décider ? Expose ta situation.",
  ctx_desc_relax: "Moment détente : on décompresse et on se change les idées.",
  ctx_desc_seduction: "Séduction, flirt et intimité : ambiance complice et sensuelle (jamais explicite).",
  clear_thread: "Effacer la conversation",
  clear_thread_q: "Effacer toute cette conversation ?",
  clear_thread_desc: "Cela efface uniquement les messages de ce sujet. Ta note de contexte reste enregistrée.",
  thread_cleared: "Conversation effacée",
  clear_confirm: "Effacer",
  note_btn: "Note de contexte",
  note_title: "Contexte du sujet (mémorisé par l'IA)",
  note_ph: "Décris le sujet, ta situation, ce que l'IA doit toujours retenir…",
  note_hint: "Gardé en mémoire même si tu effaces la conversation. Non compté dans tes messages.",
  note_saved: "Contexte enregistré",
  mic_hint: "Parler",
  mic_listening: "J'écoute… touche pour arrêter",
  mic_unsupported: "La saisie vocale n'est pas prise en charge sur ce navigateur",
  notif_settings: "Réglages des notifications",
  notif_settings_desc: "Choisis les notifications push que tu reçois.",
  push_morning: "Boost du matin",
  push_midday: "Point de midi",
  push_coach: "Idée du Coach (IA)",
  push_evening: "Bilan du soir",
  push_night: "Préparer demain",
  push_reengage: "Tu nous manques",
  push_coach_note: "Nécessite l'abonnement Coach.",
  notif_prefs_saved: "Préférences enregistrées",
  intent_label: "Tu cherches quoi aujourd'hui ?",
  intent_none: "Général",
  intent_work: "Travail sérieux",
  intent_company: "Compagnie",
  intent_advice: "Conseil",
  intent_relax: "Se détendre",
  intent_seduction: "Séduction",
  intent_saved: "C'est noté — je m'adapte à ta journée 👍",
  nav_login: "Se connecter", nav_cta: "Activer à vie", nav_logout: "Déconnexion", nav_dashboard: "Dashboard", nav_admin: "Admin",
  hero_badge: "100% automatisé · Psychologie positive",
  hero_t1: "GaimTime : Créez votre Temps Personnel,", hero_hl: "vivez selon vos règles.", preview_explain: "Ton horloge GaimTime avance plus vite → tu finis ta journée plus tôt et tu gagnes du Temps Personnel.",
  hero_sub: "Règle ton horloge, gagne jusqu'à 20 minutes par heure et libère du temps pour ce qui compte vraiment.",
  hero_cta: "Activer à vie", hero_cta_sub: "· 4,99 €",
  hero_trust: "Paiement unique · Sans abonnement caché · Stripe sécurisé",
  today_gain: "Aujourd'hui · Gain 10 min/h",
  f1_t: "Deux horloges synchronisées", f1_d: "Votre heure réelle et votre Temps GaimTime accéléré, mis à jour seconde par seconde.",
  f2_t: "Gain cumulé en direct", f2_d: "Visualisez le temps que vous récupérez : jusqu'à 1h20 sur une journée de 8h.",
  f3_t: "Planning compressé sur 24h", f3_d: "Projetez vos tâches dans une journée compressée et atteignez vos objectifs plus tôt.",
  comp_badge: "GaimTime Coach & Compagnon", comp_t: "Un coach & compagnon IA qui vous connaît vraiment.",
  comp_d: "Pas un simple chatbot. Un ami intime et honnête, qui vous écoute, vous conseille et vous pousse à agir. Amour, doutes, projets, peurs — il est là, sans filtre.",
  comp_avail: "Disponible via l'abonnement Coach & Compagnon (9,99 €/mois) depuis votre Dashboard.",
  chat_demo_q: "J'ai une grosse décision à prendre demain…", chat_demo_a: "Ok, respire. Raconte-moi tout, on va démêler ça ensemble. Qu'est-ce qui te bloque vraiment ?",
  pricing_t: "Un seul paiement. Un accès à vie.", pricing_sub: "Aucun abonnement caché pour l'application. Le Coach & Compagnon IA reste optionnel.",
  price_life: "/ à vie", pf1: "Dashboard complet & horloges GaimTime", pf2: "Planning compressé sur 24h", pf3: "Gagnez jusqu'à 20 min/heure", pf4: "Mises à jour à vie",
  pricing_cta: "Activer à vie",
  footer_contact: "Contact", footer_cgv: "CGV", footer_legal: "Mentions légales",
  contact_title: "Nous contacter", contact_desc: "Une question ? Écrivez-nous à cette adresse :", contact_copy_or: "Ou ouvrir votre logiciel de messagerie →", copied: "Email copié !",
  gain: "Gain", objective_t: "Objectif de gain", objective_d: "Choisis les minutes que tu veux gagner chaque heure", minh: "min/h", start: "Début",
  real_clock: "Heure réelle", gaim_clock: "Heure GaimTime", conv: "1h GaimTime = {n} min réelles",
  gain_cumule: "Gain cumulé", day8: "Journée (8h)", reset_counters: "Reset compteurs",
  traj_t: "Trajectoire de gain (minutes / heure de travail)", open_planning: "Ouvrir le Planning (24h)", hide_planning: "Masquer le Planning",
  coach_btn: "Discuter avec mon Coach & Compagnon", timezone: "Fuseau horaire",
  planning_t: "Planning compressé", add_task: "Ajouter une tâche…", reset: "Reset", now: "maintenant", real: "réel",
  coach_title: "GaimTime Coach & Compagnon", coach_empty: "Salut ! Je suis là pour toi. Dis-moi ce qui te trotte dans la tête aujourd'hui. 👋", coach_ph: "Écris à ton coach…",
  create_acc: "Créer un compte", sign_in: "Se connecter", firstname: "Prénom", lastname: "Nom", email: "Email", password: "Mot de passe", company: "Société (optionnel)",
  comp_intro: "Faites connaissance avec votre Coach & Compagnon", comp_intro_sub: "Optionnel — pour un coach IA qui vous connaît vraiment.",
  situation_ph: "Ta situation de vie (travail, famille…)", goals_ph: "Tes objectifs du moment", interests_ph: "Tes centres d'intérêt",
  login_submit: "Se connecter", secure_pay: "Paiement sécurisé via Stripe",
  coachdlg_desc: "Débloquez votre coach & compagnon de vie IA : un ami intime, complice et honnête, disponible 24/7.", permonth: "/ mois", activate_coach: "Activer le Coach & Compagnon — 9,99 €/mois",
  ps_checking: "Vérification de votre paiement…", ps_wait_t: "Un instant…", ps_success_life: "Accès à vie activé !", ps_success_coach: "Coach & Compagnon activé !",
  ps_done: "C'est fait !", ps_oops: "Oups", ps_go_dash: "Aller au Dashboard", ps_notfound: "Session de paiement introuvable.", ps_slow: "Le paiement prend plus de temps que prévu. Vérifiez votre Dashboard dans quelques instants.",
  lang_label: "Langue", notif_on: "Notifications activées 🔔", notif_off: "Notifications désactivées", tz_saved: "Fuseau horaire enregistré",
  hiw_open: "Comment ça marche ?",
  hiw_title: "Et si ta journée finissait plus tôt ?",
  hiw_intro: "GaimTime accélère ton horloge. Tu avances plus vite que le temps réel, donc ton cerveau vise une fin de journée plus proche — et tu termines en avance.",
  hiw_s1_t: "Choisis ton gain", hiw_s1_d: "Tu décides combien de minutes gagner par heure : 5, 10, 15 ou 20 min.",
  hiw_s2_t: "Ton horloge GaimTime accélère", hiw_s2_d: "Pendant que le temps réel avance normalement, ton horloge GaimTime prend de l'avance, seconde après seconde.",
  hiw_s3_t: "Tu finis plus tôt", hiw_s3_d: "Quand ton horloge GaimTime affiche 17h, il n'est en réalité que 16h10. Tu as gagné 50 minutes.",
  hiw_s4_t: "Planifie tes tâches avec alertes", hiw_s4_d: "Planifie tes tâches en heure GaimTime et reçois une alerte sonnerie pour chaque étape.",
  hiw_example: "Exemple : avec +10 min/heure, sur une journée de 8h, ta journée GaimTime « se termine » alors qu'il te reste 1h20 de temps réel. Cette avance te pousse à rester concentré.",
  hiw_read: "Lire", hiw_listen: "Écouter", hiw_loading: "Génération de la voix…", hiw_playing: "Lecture…",
  offer_clear_t: "Une offre claire. Zéro surprise.", offer_clear_sub: "Ton accès à vie te donne tout l'essentiel. Le Coach, c'est le petit plus quand tu le veux.",
  card1_tag: "Accès à vie · paiement unique", card2_tag: "Option premium", card2_optional: "(optionnel)",
  card2_title: "GaimTime Coach", card2_price: "9,99 €", card2_feat: "Coach personnel illimité", card2_feat2: "Motivation, décisions, recadrage", card2_note: "Activable depuis ton espace une fois connecté",
  pricing_reassure: "GaimTime fonctionne à 100% sans le Coach. Le Coach est une option, jamais obligatoire.",
  listen_msg: "Écouter",
  faq_title: "Questions fréquentes",
  faq_q1: "Le temps s'accélère vraiment ?", faq_a1: "Non 🙂 C'est un principe de psychologie : ton horloge GaimTime affichée avance plus vite, ce qui pousse ton cerveau à finir plus tôt. Le temps réel ne change pas.",
  faq_q2: "Je paie une seule fois ?", faq_a2: "Oui, 4,99€ à vie, un seul paiement. Le Coach IA est une option séparée (9,99€/mois), jamais obligatoire.",
  faq_q3: "C'est quoi le GaimTime Coach ?", faq_a3: "Un coach personnel IA qui te motive et t'aide dans tes décisions. Optionnel, activable depuis ton espace.",
  faq_q4: "Ça marche sur mobile / hors ligne ?", faq_a4: "Oui, GaimTime est une app installable (PWA) sur ton téléphone, avec accès hors ligne.",
  faq_q5: "Mes données sont-elles privées ?", faq_a5: "Oui, tes données restent privées et sécurisées ; le paiement passe par Stripe.",
  faq_q6: "Puis-je annuler l'abonnement Coach ?", faq_a6: "Oui, à tout moment. L'accès à vie GaimTime, lui, reste acquis.",
  demo_title: "Visualise le temps que tu gagnes", demo_sub: "Plus tu gagnes de minutes par heure, plus ta journée se termine tôt.", demo_classic: "Journée classique", demo_withgaim: "Avec GaimTime", demo_saved: "{v} gagnées 🎉",
  forgot_pw: "Mot de passe oublié ?", forgot_title: "Réinitialiser le mot de passe", forgot_desc: "Entre ton email, on t'envoie un lien pour choisir un nouveau mot de passe.", forgot_submit: "Envoyer le lien", forgot_sent: "Si un compte existe pour cet email, un lien de réinitialisation vient d'être envoyé.", back_to_login: "← Retour à la connexion",
  reset_title: "Nouveau mot de passe", reset_desc: "Choisis un nouveau mot de passe pour ton compte.", reset_new_pw: "Nouveau mot de passe", reset_confirm_pw: "Confirme le mot de passe", reset_submit: "Mettre à jour le mot de passe", reset_success: "Mot de passe mis à jour ! Tu peux te connecter.", reset_mismatch: "Les mots de passe ne correspondent pas.", reset_invalid_link: "Lien invalide ou expiré. Redemande un lien.", reset_short: "Le mot de passe doit contenir au moins 6 caractères.",
  edit_profile: "Modifier mon profil", profile_title: "Mon profil", profile_saved: "Profil mis à jour", save: "Enregistrer", cancel: "Annuler",
  coach_cfg_btn: "Configurer mon Coach", coach_cfg_title: "Configure ton Coach & Compagnon", coach_cfg_desc: "Tout est optionnel — façonne un coach qui te ressemble. Modifiable à tout moment, pour le travail, la vie ou autre.",
  cfg_gender: "Genre du coach", cfg_gender_m: "Homme", cfg_gender_f: "Femme",
  cfg_type: "Spécialité du coach", type_work: "Travail", type_life: "Vie", type_love: "Amour & relations", type_intimate: "Intimité", type_company: "Compagnie", type_other: "Autre",
  cfg_tone: "Ton", tone_direct: "Direct & cash", tone_soft: "Doux & bienveillant", tone_motiv: "Motivant",
  cfg_nickname: "Comment le coach doit-il t'appeler ?", cfg_challenges: "Tes défis ou blocages actuels", cfg_values: "Ce qui compte le plus pour toi", cfg_motivation: "Ce qui te motive",
  support_btn: "Support", tickets_title: "Support & Discussion", tickets_desc: "Une question ? Écris-nous, on te répond ici.", ticket_new: "Nouveau message", ticket_subject: "Objet", ticket_message: "Ton message", ticket_send: "Envoyer", ticket_reply_ph: "Écris ta réponse…", ticket_empty: "Aucune discussion pour l'instant.", ticket_open: "Ouvert", ticket_closed: "Fermé", ticket_sent: "Message envoyé !", ticket_back: "← Retour", ticket_you: "Toi", ticket_team: "Équipe GaimTime", coach_daily_left: "messages restants aujourd'hui",
  coach_limit_title: "Tu as atteint 150 messages aujourd'hui 👏", coach_limit_desc: "Reviens demain… ou continue tout de suite avec un pack.", coach_buy_pack: "Continuer · +150 messages · 2€", coach_bonus_label: "bonus",
  err_generic: "Une erreur est survenue. Réessaie.",
};

const es = {
  dev_rename: "Renombrar",
  dev_rename_ph: "Nombre del dispositivo",
  push_blocks: "Alarmas de los bloques del planificador",
  pv_pomodoro: "Pomodoro",
  pv_pomodoro_done: "Pomodoro añadido: 25 min foco / 5 min pausa",
  pv_sound: "Sonido de alarma",
  pv_test: "Probar",
  snd_chime: "Campanilla",
  snd_bell: "Campana",
  snd_beep: "Pitido",
  snd_soft: "Suave",
  banner_text: "Añade GaimTime a tu pantalla de inicio",
  banner_btn: "Instalar",
  ia_and_title: "En Android (Chrome)",
  ia_and_1: "Abre el menú ⋮ de Chrome (arriba a la derecha).",
  ia_and_2: "Toca 'Instalar y crear acceso directo'.",
  ia_and_3: "Toca 'Instalar' — ¡listo!",
  install_app: "Instalar la app",
  ia_title: "Instala GaimTime en tu teléfono",
  ia_desc: "Añade GaimTime a tu pantalla de inicio: acceso rápido, pantalla completa, como una app real.",
  ia_install_btn: "Instalar ahora",
  ia_installed: "GaimTime ya está instalada en este dispositivo 🎉",
  ia_ios_title: "En iPhone / iPad (Safari)",
  ia_ios_1: "Toca el botón Compartir en la parte inferior de Safari.",
  ia_ios_2: "Elige 'Añadir a pantalla de inicio'.",
  ia_ios_3: "Toca 'Añadir' — ¡listo!",
  ia_soon: "Captura próximamente",
  pv_add: "Añadir un bloque",
  pv_label: "Nombre",
  pv_type: "Tipo",
  pv_task: "Tarea",
  pv_break: "Pausa",
  pv_start: "Inicio",
  pv_end: "Fin",
  pv_alarm_start: "Alarma al inicio",
  pv_alarm_end: "Alarma al final",
  pv_free: "Libre",
  pv_save: "Añadir",
  pv_cancel: "Cancelar",
  pv_delete: "Eliminar",
  pv_invalid: "El fin debe ser posterior al inicio, dentro de tu día.",
  pv_none: "Aún no hay bloques. Tu día está libre — ¡añade el primero!",
  pv_fired: "Es la hora",
  pv_stop: "Detener",
  lifetime_badge: "De por vida",
  daystart_title: "¡Tu día GaimTime comienza! ⏳",
  daystart_body: "Empieza a ganar — tu día comprimido ha comenzado.",
  chpwd_menu: "Cambiar contraseña",
  chpwd_title: "Cambiar contraseña",
  chpwd_current: "Contraseña actual",
  chpwd_new: "Nueva contraseña",
  chpwd_confirm: "Confirmar nueva contraseña",
  chpwd_save: "Guardar",
  chpwd_success: "Contraseña cambiada con éxito",
  chpwd_err_current: "La contraseña actual es incorrecta",
  chpwd_err_short: "Contraseña demasiado corta (mín 6 caracteres)",
  chpwd_err_match: "Las contraseñas no coinciden",
  chpwd_err_same: "La nueva contraseña debe ser diferente",
  pv_reset: "Borrar todo",
  menu_account: "Mi cuenta",
  menu_notif: "Notificaciones",
  menu_help: "Guía / Ayuda",
  state_on: "Activado",
  state_off: "Desactivado",
  ob_next: "Siguiente",
  ob_back: "Atrás",
  ob_skip: "Omitir",
  ob_done: "¡Entendido!",
  ob_t1: "Bienvenido a GaimTime 👋",
  ob_d1: "Un recorrido rápido para aprovechar tu tiempo. Dura 20 segundos.",
  ob_t2: "Tus dos relojes",
  ob_d2: "A la izquierda, la hora real. A la derecha, tu GaimTime acelerado. La diferencia es el tiempo que ganas.",
  ob_t3: "Configura tu día",
  ob_d3: "Elige tu objetivo de ganancia y hora de inicio. 'Abrir Planning (24h)' organiza tus bloques.",
  ob_t4: "Tu menú de cuenta",
  ob_d4: "Arriba a la derecha: notificaciones, configuración del Coach IA, reloj en notificaciones, mis dispositivos, facturas y ayuda.",
  ob_t5: "Tu Coach IA",
  ob_d5: "Chatea con tu Coach y Compañero cuando quieras — te motiva como un amigo cercano.",
  lc_title: "Reloj en las notificaciones",
  lc_on: "Reloj GaimTime activado en tus notificaciones",
  lc_off: "Reloj de notificaciones desactivado",
  lc_denied: "Permite las notificaciones para mostrar el reloj",
  lc_unsupported: "Tu dispositivo no admite esto",
  lc_gaim: "GaimTime",
  lc_gain: "Ganancia",
  devices_title: "Mis dispositivos",
  devices_desc: "Puedes usar hasta 2 dispositivos. Desconecta uno para liberar espacio.",
  dev_this_device: "Este dispositivo",
  devices_empty: "Sin dispositivos activos.",
  dev_limit_title: "Demasiados dispositivos",
  dev_limit_desc: "Has alcanzado el límite de 2 dispositivos. Desconecta uno para continuar en este.",
  dev_disconnect: "Desconectar",
  dev_seen: "Activo",
  hiw_audio_error: "Audio no disponible por ahora. Inténtalo de nuevo en un momento.",
  upgrade_super_btn: "Pasar a Súper IA", plan_standard: "Coach Estándar", plan_standard_desc: "Asistente de IA rápido y natural", plan_super: "Súper IA", plan_super_desc: "La IA más inteligente, más mensajes y voz al día", plan_super_tag: "El mejor", activate_super: "Activar Súper IA", ps_success_super: "¡Súper IA activada!", tts_limit_reached: "Límite diario de lectura por voz alcanzado.",
  my_invoices: "Mis facturas",
  download: "Descargar",
  no_invoices: "Aún no hay facturas.",
  ctx_desc_general: "Charla libre: habla de lo que quieras, tu coach está aquí para ti.",
  ctx_desc_work: "Modo trabajo: concentración y eficacia — tu coach te ayuda a avanzar.",
  ctx_desc_company: "Solo compañía: charlamos, reímos, te sientes escuchado.",
  ctx_desc_advice: "¿Necesitas un consejo o ayuda para decidir? Cuenta tu situación.",
  ctx_desc_relax: "Momento de relax: desconecta y despeja la mente.",
  ctx_desc_seduction: "Seducción, coqueteo e intimidad: ambiente cómplice y sensual (nunca explícito).",
  clear_thread: "Borrar conversación",
  clear_thread_q: "¿Borrar toda esta conversación?",
  clear_thread_desc: "Solo borra los mensajes de este tema. Tu nota de contexto se mantiene.",
  thread_cleared: "Conversación borrada",
  clear_confirm: "Borrar",
  note_btn: "Nota de contexto",
  note_title: "Contexto del tema (recordado por la IA)",
  note_ph: "Describe el tema, tu situación, lo que la IA debe recordar siempre…",
  note_hint: "Se guarda aunque borres la conversación. No cuenta en tus mensajes.",
  note_saved: "Contexto guardado",
  mic_hint: "Hablar",
  mic_listening: "Escuchando… toca para parar",
  mic_unsupported: "La entrada de voz no es compatible con este navegador",
  notif_settings: "Ajustes de notificaciones",
  notif_settings_desc: "Elige qué notificaciones push recibes.",
  push_morning: "Impulso matinal",
  push_midday: "Chequeo del mediodía",
  push_coach: "Idea del Coach (IA)",
  push_evening: "Resumen de la tarde",
  push_night: "Preparar mañana",
  push_reengage: "Te echamos de menos",
  push_coach_note: "Requiere la suscripción Coach.",
  notif_prefs_saved: "Preferencias guardadas",
  intent_label: "¿Qué necesitas hoy?",
  intent_none: "General",
  intent_work: "Trabajo serio",
  intent_company: "Compañía",
  intent_advice: "Consejo",
  intent_relax: "Relajarse",
  intent_seduction: "Seducción",
  intent_saved: "Anotado — me adapto a tu día 👍",
  nav_login: "Iniciar sesión", nav_cta: "Activar de por vida", nav_logout: "Cerrar sesión", nav_dashboard: "Panel", nav_admin: "Admin",
  hero_badge: "100% automatizado · Psicología positiva",
  hero_t1: "GaimTime: Crea tu Tiempo Personal,", hero_hl: "vive según tus reglas.", preview_explain: "Tu reloj GaimTime avanza más rápido → terminas tu día antes y ganas Tiempo Personal.",
  hero_sub: "Deja de sufrir el paso del tiempo. Ya sea que trabajes, estudies u organices tus días, gana hasta 20 minutos por hora y libera tiempo para lo que de verdad importa.",
  hero_cta: "Activar de por vida", hero_cta_sub: "· 4,99 €",
  hero_trust: "Pago único · Sin suscripción oculta · Seguro con Stripe",
  today_gain: "Hoy · Ganancia 10 min/h",
  f1_t: "Dos relojes sincronizados", f1_d: "Tu hora real y tu Tiempo GaimTime acelerado, actualizados segundo a segundo.",
  f2_t: "Ganancia acumulada en vivo", f2_d: "Ve el tiempo que recuperas: hasta 1h20 en una jornada de 8h.",
  f3_t: "Planificación comprimida 24h", f3_d: "Proyecta tus tareas en un día comprimido y alcanza tus metas antes.",
  comp_badge: "GaimTime Coach & Compañero", comp_t: "Un coach y compañero IA que te conoce de verdad.",
  comp_d: "No un simple chatbot. Un amigo íntimo y honesto que te escucha, te aconseja y te impulsa a actuar. Amor, dudas, proyectos, miedos — está ahí, sin filtros.",
  comp_avail: "Disponible con la suscripción Coach & Compañero (9,99 €/mes) desde tu Panel.",
  chat_demo_q: "Tengo una gran decisión que tomar mañana…", chat_demo_a: "Vale, respira. Cuéntamelo todo, lo resolveremos juntos. ¿Qué te bloquea de verdad?",
  pricing_t: "Un pago. Acceso de por vida.", pricing_sub: "Sin suscripción oculta para la app. El Compañero IA es opcional.",
  price_life: "/ de por vida", pf1: "Panel completo y relojes GaimTime", pf2: "Planificación comprimida 24h", pf3: "Gana hasta 20 min/hora", pf4: "Actualizaciones de por vida",
  pricing_cta: "Activar de por vida",
  footer_contact: "Contacto", footer_cgv: "Términos", footer_legal: "Aviso legal",
  contact_title: "Contáctanos", contact_desc: "¿Una pregunta? Escríbenos a esta dirección:", contact_copy_or: "O abre tu app de correo →", copied: "¡Correo copiado!",
  gain: "Ganancia", objective_t: "Objetivo de ganancia", objective_d: "Elige los minutos que quieres ganar cada hora", minh: "min/h", start: "Inicio",
  real_clock: "Hora real", gaim_clock: "Hora GaimTime", conv: "1h GaimTime = {n} min reales",
  gain_cumule: "Ganancia acumulada", day8: "Jornada (8h)", reset_counters: "Reiniciar contadores",
  traj_t: "Trayectoria de ganancia (minutos / hora de trabajo)", open_planning: "Abrir Planificación (24h)", hide_planning: "Ocultar Planificación",
  coach_btn: "Hablar con mi Coach & Compañero", timezone: "Zona horaria",
  planning_t: "Planificación comprimida", add_task: "Añadir tarea…", reset: "Reiniciar", now: "ahora", real: "real",
  coach_title: "GaimTime Coach & Compañero", coach_empty: "¡Hola! Estoy aquí para ti. Cuéntame qué te ronda la cabeza hoy. 👋", coach_ph: "Escribe a tu coach…",
  create_acc: "Crear cuenta", sign_in: "Iniciar sesión", firstname: "Nombre", lastname: "Apellido", email: "Correo", password: "Contraseña", company: "Empresa (opcional)",
  comp_intro: "Conoce a tu Coach & Compañero", comp_intro_sub: "Opcional — para un coach IA que te conoce de verdad.",
  situation_ph: "Tu situación de vida (trabajo, familia…)", goals_ph: "Tus objetivos actuales", interests_ph: "Tus intereses",
  login_submit: "Iniciar sesión", secure_pay: "Pago seguro con Stripe",
  coachdlg_desc: "Desbloquea tu coach y compañero de vida IA: un amigo íntimo y honesto, disponible 24/7.", permonth: "/ mes", activate_coach: "Activar Coach & Compañero — 9,99 €/mes",
  ps_checking: "Verificando tu pago…", ps_wait_t: "Un momento…", ps_success_life: "¡Acceso de por vida activado!", ps_success_coach: "¡Coach & Compañero activado!",
  ps_done: "¡Listo!", ps_oops: "Vaya", ps_go_dash: "Ir al Panel", ps_notfound: "Sesión de pago no encontrada.", ps_slow: "El pago tarda más de lo previsto. Revisa tu Panel en unos instantes.",
  lang_label: "Idioma", notif_on: "Notificaciones activadas 🔔", notif_off: "Notificaciones desactivadas", tz_saved: "Zona horaria guardada",
  hiw_open: "¿Cómo funciona?",
  hiw_title: "¿Y si tu día terminara antes?",
  hiw_intro: "GaimTime acelera tu reloj. Avanzas más rápido que el tiempo real, así tu mente apunta a un final de jornada más cercano — y terminas antes.",
  hiw_s1_t: "Elige tu ganancia", hiw_s1_d: "Decides cuántos minutos ganar por hora: 5, 10, 15 o 20 min.",
  hiw_s2_t: "Tu reloj GaimTime acelera", hiw_s2_d: "Mientras el tiempo real avanza normal, tu reloj GaimTime toma ventaja, segundo a segundo.",
  hiw_s3_t: "Terminas antes", hiw_s3_d: "Cuando tu reloj GaimTime marca las 17h, en realidad solo son las 16:10. Has ganado 50 minutos.",
  hiw_s4_t: "Planifica tus tareas con alertas", hiw_s4_d: "Programa tus tareas en hora GaimTime y recibe una alerta con tono para cada etapa.",
  hiw_example: "Ejemplo: con +10 min/hora, en una jornada de 8h tu día GaimTime «termina» cuando aún te quedan 1h20 de tiempo real. Esa ventaja te mantiene concentrado.",
  hiw_read: "Leer", hiw_listen: "Escuchar", hiw_loading: "Generando la voz…", hiw_playing: "Reproduciendo…",
  offer_clear_t: "Una oferta clara. Cero sorpresas.", offer_clear_sub: "Tu acceso de por vida te da todo lo esencial. El Coach es un extra, cuando quieras.",
  card1_tag: "Acceso de por vida · pago único", card2_tag: "Opción premium", card2_optional: "(opcional)",
  card2_title: "GaimTime Coach", card2_price: "9,99 €", card2_feat: "Coach personal ilimitado", card2_feat2: "Motivación, decisiones, reenfoque", card2_note: "Activable desde tu espacio una vez conectado",
  pricing_reassure: "GaimTime funciona al 100% sin el Coach. El Coach es una opción, nunca obligatoria.",
  listen_msg: "Escuchar",
  faq_title: "Preguntas frecuentes",
  faq_q1: "¿El tiempo se acelera de verdad?", faq_a1: "No 🙂 Es un principio de psicología: tu reloj GaimTime mostrado avanza más rápido, lo que empuja a tu cerebro a terminar antes. El tiempo real no cambia.",
  faq_q2: "¿Pago una sola vez?", faq_a2: "Sí, 4,99€ de por vida, un único pago. El Coach IA es una opción aparte (9,99€/mes), nunca obligatoria.",
  faq_q3: "¿Qué es el GaimTime Coach?", faq_a3: "Un coach personal con IA que te motiva y te ayuda en tus decisiones. Opcional, activable desde tu espacio.",
  faq_q4: "¿Funciona en móvil / sin conexión?", faq_a4: "Sí, GaimTime es una app instalable (PWA) en tu teléfono, con acceso sin conexión.",
  faq_q5: "¿Mis datos son privados?", faq_a5: "Sí, tus datos son privados y seguros; el pago se gestiona con Stripe.",
  faq_q6: "¿Puedo cancelar la suscripción del Coach?", faq_a6: "Sí, cuando quieras. Tu acceso de por vida a GaimTime sigue siendo tuyo.",
  demo_title: "Visualiza el tiempo que ganas", demo_sub: "Cuantos más minutos ganas por hora, antes termina tu día.", demo_classic: "Día clásico", demo_withgaim: "Con GaimTime", demo_saved: "{v} ganadas 🎉",
  forgot_pw: "¿Olvidaste tu contraseña?", forgot_title: "Restablecer la contraseña", forgot_desc: "Introduce tu email y te enviaremos un enlace para elegir una nueva contraseña.", forgot_submit: "Enviar el enlace", forgot_sent: "Si existe una cuenta para este email, acabamos de enviar un enlace de restablecimiento.", back_to_login: "← Volver a iniciar sesión",
  reset_title: "Nueva contraseña", reset_desc: "Elige una nueva contraseña para tu cuenta.", reset_new_pw: "Nueva contraseña", reset_confirm_pw: "Confirma la contraseña", reset_submit: "Actualizar la contraseña", reset_success: "¡Contraseña actualizada! Ya puedes iniciar sesión.", reset_mismatch: "Las contraseñas no coinciden.", reset_invalid_link: "Enlace inválido o caducado. Solicita uno nuevo.", reset_short: "La contraseña debe tener al menos 6 caracteres.",
  edit_profile: "Editar mi perfil", profile_title: "Mi perfil", profile_saved: "Perfil actualizado", save: "Guardar", cancel: "Cancelar",
  coach_cfg_btn: "Configurar mi Coach", coach_cfg_title: "Configura tu Coach y Compañero", coach_cfg_desc: "Todo opcional — crea un coach que encaje contigo. Cámbialo cuando quieras, para el trabajo, la vida u otro.",
  cfg_gender: "Género del coach", cfg_gender_m: "Hombre", cfg_gender_f: "Mujer",
  cfg_type: "Especialidad del coach", type_work: "Trabajo", type_life: "Vida", type_love: "Amor y relaciones", type_intimate: "Intimidad", type_company: "Compañía", type_other: "Otro",
  cfg_tone: "Tono", tone_direct: "Directo y sincero", tone_soft: "Suave y cercano", tone_motiv: "Motivador",
  cfg_nickname: "¿Cómo debe llamarte el coach?", cfg_challenges: "Tus retos o bloqueos actuales", cfg_values: "Lo que más te importa", cfg_motivation: "Lo que te motiva",
  support_btn: "Soporte", tickets_title: "Soporte y Chat", tickets_desc: "¿Una pregunta? Escríbenos, te respondemos aquí.", ticket_new: "Nuevo mensaje", ticket_subject: "Asunto", ticket_message: "Tu mensaje", ticket_send: "Enviar", ticket_reply_ph: "Escribe tu respuesta…", ticket_empty: "Aún no hay conversaciones.", ticket_open: "Abierto", ticket_closed: "Cerrado", ticket_sent: "¡Mensaje enviado!", ticket_back: "← Volver", ticket_you: "Tú", ticket_team: "Equipo GaimTime", coach_daily_left: "mensajes restantes hoy",
  coach_limit_title: "Has alcanzado 150 mensajes hoy 👏", coach_limit_desc: "Vuelve mañana… o sigue ahora mismo con un pack.", coach_buy_pack: "Continuar · +150 mensajes · 2€", coach_bonus_label: "bonus",
  err_generic: "Algo salió mal. Inténtalo de nuevo.",
};

const de = {
  dev_rename: "Umbenennen",
  dev_rename_ph: "Gerätename",
  push_blocks: "Alarme der Planungsblöcke",
  pv_pomodoro: "Pomodoro",
  pv_pomodoro_done: "Pomodoro hinzugefügt: 25 Min Fokus / 5 Min Pause",
  pv_sound: "Alarmton",
  pv_test: "Test",
  snd_chime: "Glockenspiel",
  snd_bell: "Glocke",
  snd_beep: "Piep",
  snd_soft: "Sanft",
  banner_text: "Füge GaimTime zum Startbildschirm hinzu",
  banner_btn: "Installieren",
  ia_and_title: "Auf Android (Chrome)",
  ia_and_1: "Öffne das Chrome-Menü ⋮ (oben rechts).",
  ia_and_2: "Tippe auf 'Installieren und Verknüpfung erstellen'.",
  ia_and_3: "Tippe auf 'Installieren' — fertig!",
  install_app: "App installieren",
  ia_title: "GaimTime auf deinem Handy installieren",
  ia_desc: "Füge GaimTime zu deinem Startbildschirm hinzu: schneller Zugriff, Vollbild, wie eine echte App.",
  ia_install_btn: "Jetzt installieren",
  ia_installed: "GaimTime ist auf diesem Gerät bereits installiert 🎉",
  ia_ios_title: "Auf iPhone / iPad (Safari)",
  ia_ios_1: "Tippe unten in Safari auf Teilen.",
  ia_ios_2: "Wähle 'Zum Home-Bildschirm'.",
  ia_ios_3: "Tippe auf 'Hinzufügen' — fertig!",
  ia_soon: "Screenshot folgt",
  pv_add: "Block hinzufügen",
  pv_label: "Name",
  pv_type: "Typ",
  pv_task: "Aufgabe",
  pv_break: "Pause",
  pv_start: "Start",
  pv_end: "Ende",
  pv_alarm_start: "Alarm am Anfang",
  pv_alarm_end: "Alarm am Ende",
  pv_free: "Frei",
  pv_save: "Hinzufügen",
  pv_cancel: "Abbrechen",
  pv_delete: "Löschen",
  pv_invalid: "Das Ende muss nach dem Start liegen, innerhalb deines Tages.",
  pv_none: "Noch kein Block. Dein Tag ist frei — füge den ersten hinzu!",
  pv_fired: "Es ist Zeit",
  pv_stop: "Stoppen",
  lifetime_badge: "Lebenslang",
  daystart_title: "Dein GaimTime-Tag beginnt! ⏳",
  daystart_body: "Loslegen — dein komprimierter Tag hat begonnen.",
  chpwd_menu: "Passwort ändern",
  chpwd_title: "Passwort ändern",
  chpwd_current: "Aktuelles Passwort",
  chpwd_new: "Neues Passwort",
  chpwd_confirm: "Neues Passwort bestätigen",
  chpwd_save: "Speichern",
  chpwd_success: "Passwort erfolgreich geändert",
  chpwd_err_current: "Aktuelles Passwort ist falsch",
  chpwd_err_short: "Passwort zu kurz (min. 6 Zeichen)",
  chpwd_err_match: "Passwörter stimmen nicht überein",
  chpwd_err_same: "Neues Passwort muss anders sein",
  pv_reset: "Alles löschen",
  menu_account: "Mein Konto",
  menu_notif: "Benachrichtigungen",
  menu_help: "Anleitung / Hilfe",
  state_on: "An",
  state_off: "Aus",
  ob_next: "Weiter",
  ob_back: "Zurück",
  ob_skip: "Überspringen",
  ob_done: "Verstanden!",
  ob_t1: "Willkommen bei GaimTime 👋",
  ob_d1: "Eine kurze Tour, um deine Zeit optimal zu nutzen. Dauert 20 Sekunden.",
  ob_t2: "Deine zwei Uhren",
  ob_d2: "Links die echte Zeit. Rechts deine beschleunigte GaimTime. Der Unterschied ist deine gewonnene Zeit.",
  ob_t3: "Richte deinen Tag ein",
  ob_d3: "Wähle dein Gewinnziel und deine Startzeit. 'Planung öffnen (24h)' organisiert deine Zeitblöcke.",
  ob_t4: "Dein Kontomenü",
  ob_d4: "Oben rechts: Benachrichtigungen, KI-Coach-Einrichtung, Uhr in Benachrichtigungen, meine Geräte, Rechnungen und Hilfe.",
  ob_t5: "Dein KI-Coach",
  ob_d5: "Chatte jederzeit mit deinem Coach & Begleiter — er motiviert dich wie ein guter Freund.",
  lc_title: "Uhr in Benachrichtigungen",
  lc_on: "GaimTime-Uhr in deinen Benachrichtigungen aktiviert",
  lc_off: "Benachrichtigungsuhr deaktiviert",
  lc_denied: "Erlaube Benachrichtigungen, um die Uhr anzuzeigen",
  lc_unsupported: "Dein Gerät unterstützt das nicht",
  lc_gaim: "GaimTime",
  lc_gain: "Gewinn",
  devices_title: "Meine Geräte",
  devices_desc: "Du kannst bis zu 2 Geräte nutzen. Trenne eines, um einen Platz freizugeben.",
  dev_this_device: "Dieses Gerät",
  devices_empty: "Kein aktives Gerät.",
  dev_limit_title: "Zu viele Geräte",
  dev_limit_desc: "Du hast das Limit von 2 Geräten erreicht. Trenne ein Gerät, um hier fortzufahren.",
  dev_disconnect: "Trennen",
  dev_seen: "Aktiv",
  hiw_audio_error: "Audio momentan nicht verfügbar. Bitte versuche es gleich noch einmal.",
  upgrade_super_btn: "Auf Super-KI upgraden", plan_standard: "Standard-Coach", plan_standard_desc: "Schneller, natürlicher KI-Assistent", plan_super: "Super-KI", plan_super_desc: "Die klügste KI, mehr Nachrichten & Stimme pro Tag", plan_super_tag: "Beste", activate_super: "Super-KI aktivieren", ps_success_super: "Super-KI aktiviert!", tts_limit_reached: "Tägliches Sprachwiedergabe-Limit erreicht.",
  my_invoices: "Meine Rechnungen",
  download: "Herunterladen",
  no_invoices: "Noch keine Rechnung.",
  ctx_desc_general: "Freies Gespräch: rede über was du willst, dein Coach ist für dich da.",
  ctx_desc_work: "Arbeitsmodus: Fokus und Effizienz — dein Coach hilft dir voranzukommen.",
  ctx_desc_company: "Einfach Gesellschaft: wir plaudern, wir lachen, du wirst gehört.",
  ctx_desc_advice: "Brauchst du Rat oder Hilfe beim Entscheiden? Schildere deine Lage.",
  ctx_desc_relax: "Entspannungszeit: abschalten und auf andere Gedanken kommen.",
  ctx_desc_seduction: "Verführung, Flirt und Intimität: spielerisch und sinnlich (nie explizit).",
  clear_thread: "Unterhaltung löschen",
  clear_thread_q: "Diese ganze Unterhaltung löschen?",
  clear_thread_desc: "Löscht nur die Nachrichten dieses Themas. Deine Kontextnotiz bleibt erhalten.",
  thread_cleared: "Unterhaltung gelöscht",
  clear_confirm: "Löschen",
  note_btn: "Kontextnotiz",
  note_title: "Themen-Kontext (von der KI gemerkt)",
  note_ph: "Beschreibe das Thema, deine Situation, was die KI sich merken soll…",
  note_hint: "Bleibt gespeichert, auch wenn du die Unterhaltung löschst. Zählt nicht zu deinen Nachrichten.",
  note_saved: "Kontext gespeichert",
  mic_hint: "Sprechen",
  mic_listening: "Ich höre… tippen zum Stoppen",
  mic_unsupported: "Spracheingabe wird von diesem Browser nicht unterstützt",
  notif_settings: "Benachrichtigungseinstellungen",
  notif_settings_desc: "Wähle, welche Push-Benachrichtigungen du erhältst.",
  push_morning: "Morgen-Boost",
  push_midday: "Mittags-Check",
  push_coach: "Coach-Idee (KI)",
  push_evening: "Abend-Rückblick",
  push_night: "Morgen vorbereiten",
  push_reengage: "Wir vermissen dich",
  push_coach_note: "Erfordert das Coach-Abo.",
  notif_prefs_saved: "Einstellungen gespeichert",
  intent_label: "Was brauchst du heute?",
  intent_none: "Allgemein",
  intent_work: "Ernsthafte Arbeit",
  intent_company: "Gesellschaft",
  intent_advice: "Rat",
  intent_relax: "Entspannen",
  intent_seduction: "Verführung",
  intent_saved: "Notiert — ich passe mich deinem Tag an 👍",
  nav_login: "Anmelden", nav_cta: "Lebenslang aktivieren", nav_logout: "Abmelden", nav_dashboard: "Dashboard", nav_admin: "Admin",
  hero_badge: "100% automatisiert · Positive Psychologie",
  hero_t1: "GaimTime: Erschaffe deine Persönliche Zeit,", hero_hl: "lebe nach deinen Regeln.", preview_explain: "Deine GaimTime-Uhr läuft schneller → du beendest deinen Tag früher und gewinnst Persönliche Zeit.",
  hero_sub: "Lass die Zeit nicht länger verrinnen. Ob du arbeitest, lernst oder deine Tage organisierst – gewinne bis zu 20 Minuten pro Stunde und schaffe Zeit für das, was wirklich zählt.",
  hero_cta: "Lebenslang aktivieren", hero_cta_sub: "· 4,99 €",
  hero_trust: "Einmalzahlung · Kein verstecktes Abo · Sicher mit Stripe",
  today_gain: "Heute · Gewinn 10 Min/Std",
  f1_t: "Zwei synchrone Uhren", f1_d: "Deine reale Zeit und deine beschleunigte GaimTime, sekundengenau aktualisiert.",
  f2_t: "Kumulierter Gewinn live", f2_d: "Sieh die Zeit, die du zurückgewinnst: bis zu 1 Std 20 an einem 8-Std-Tag.",
  f3_t: "Komprimierte 24h-Planung", f3_d: "Projiziere deine Aufgaben in einen verdichteten Tag und erreiche deine Ziele früher.",
  comp_badge: "GaimTime Coach & Begleiter", comp_t: "Ein KI-Coach & Begleiter, der dich wirklich kennt.",
  comp_d: "Kein bloßer Chatbot. Ein enger, ehrlicher Freund, der dir zuhört, dich berät und dich zum Handeln bewegt. Liebe, Zweifel, Projekte, Ängste — er ist da, ungefiltert.",
  comp_avail: "Verfügbar über das Coach & Begleiter-Abo (9,99 €/Monat) in deinem Dashboard.",
  chat_demo_q: "Ich muss morgen eine große Entscheidung treffen…", chat_demo_a: "Okay, atme. Erzähl mir alles, wir kriegen das zusammen hin. Was blockiert dich wirklich?",
  pricing_t: "Eine Zahlung. Lebenslanger Zugang.", pricing_sub: "Kein verstecktes Abo für die App. Der KI-Begleiter bleibt optional.",
  price_life: "/ lebenslang", pf1: "Komplettes Dashboard & GaimTime-Uhren", pf2: "Komprimierte 24h-Planung", pf3: "Spare bis zu 20 Min/Stunde", pf4: "Lebenslange Updates",
  pricing_cta: "Lebenslang aktivieren",
  footer_contact: "Kontakt", footer_cgv: "AGB", footer_legal: "Impressum",
  contact_title: "Kontaktiere uns", contact_desc: "Eine Frage? Schreib uns an diese Adresse:", contact_copy_or: "Oder öffne dein E-Mail-Programm →", copied: "E-Mail kopiert!",
  gain: "Gewinn", objective_t: "Gewinnziel", objective_d: "Wähle die Minuten, die du pro Stunde gewinnen möchtest", minh: "Min/Std", start: "Start",
  real_clock: "Reale Zeit", gaim_clock: "GaimTime-Stunde", conv: "1 Std GaimTime = {n} reale Min",
  gain_cumule: "Kumulierter Gewinn", day8: "Tag (8 Std)", reset_counters: "Zähler zurücksetzen",
  traj_t: "Gewinnverlauf (Minuten / Arbeitsstunde)", open_planning: "Planung öffnen (24h)", hide_planning: "Planung ausblenden",
  coach_btn: "Mit meinem Coach & Begleiter chatten", timezone: "Zeitzone",
  planning_t: "Komprimierte Planung", add_task: "Aufgabe hinzufügen…", reset: "Zurücksetzen", now: "jetzt", real: "real",
  coach_title: "GaimTime Coach & Begleiter", coach_empty: "Hey! Ich bin für dich da. Sag mir, was dir heute im Kopf herumgeht. 👋", coach_ph: "Schreib deinem Coach…",
  create_acc: "Konto erstellen", sign_in: "Anmelden", firstname: "Vorname", lastname: "Nachname", email: "E-Mail", password: "Passwort", company: "Firma (optional)",
  comp_intro: "Lerne deinen Coach & Begleiter kennen", comp_intro_sub: "Optional — für einen KI-Coach, der dich wirklich kennt.",
  situation_ph: "Deine Lebenssituation (Arbeit, Familie…)", goals_ph: "Deine aktuellen Ziele", interests_ph: "Deine Interessen",
  login_submit: "Anmelden", secure_pay: "Sichere Zahlung mit Stripe",
  coachdlg_desc: "Schalte deinen KI-Lebenscoach & Begleiter frei: ein enger, ehrlicher Freund, rund um die Uhr verfügbar.", permonth: "/ Monat", activate_coach: "Coach & Begleiter aktivieren — 9,99 €/Monat",
  ps_checking: "Zahlung wird geprüft…", ps_wait_t: "Einen Moment…", ps_success_life: "Lebenslanger Zugang aktiviert!", ps_success_coach: "Coach & Begleiter aktiviert!",
  ps_done: "Fertig!", ps_oops: "Ups", ps_go_dash: "Zum Dashboard", ps_notfound: "Zahlungssitzung nicht gefunden.", ps_slow: "Die Zahlung dauert länger als erwartet. Prüfe dein Dashboard in Kürze.",
  lang_label: "Sprache", notif_on: "Benachrichtigungen aktiviert 🔔", notif_off: "Benachrichtigungen deaktiviert", tz_saved: "Zeitzone gespeichert",
  hiw_open: "Wie funktioniert es?",
  hiw_title: "Was, wenn dein Tag früher endet?",
  hiw_intro: "GaimTime beschleunigt deine Uhr. Du bist schneller als die reale Zeit, dein Gehirn zielt auf ein früheres Tagesende — und du bist eher fertig.",
  hiw_s1_t: "Wähle deinen Gewinn", hiw_s1_d: "Du entscheidest, wie viele Minuten du pro Stunde gewinnst: 5, 10, 15 oder 20 Min.",
  hiw_s2_t: "Deine GaimTime-Uhr beschleunigt", hiw_s2_d: "Während die reale Zeit normal läuft, eilt deine GaimTime-Uhr Sekunde für Sekunde voraus.",
  hiw_s3_t: "Du bist früher fertig", hiw_s3_d: "Wenn deine GaimTime-Uhr 17 Uhr zeigt, ist es real erst 16:10. Du hast 50 Minuten gewonnen.",
  hiw_s4_t: "Plane deine Aufgaben mit Alarmen", hiw_s4_d: "Plane deine Aufgaben in GaimTime-Stunden und erhalte einen Klingelton-Alarm für jeden Schritt.",
  hiw_example: "Beispiel: bei +10 Min/Stunde „endet“ dein GaimTime-Tag über 8 Stunden, während dir noch 1 Std 20 reale Zeit bleiben. Dieser Vorsprung hält dich fokussiert.",
  hiw_read: "Lesen", hiw_listen: "Anhören", hiw_loading: "Stimme wird erzeugt…", hiw_playing: "Wiedergabe…",
  offer_clear_t: "Ein klares Angebot. Keine Überraschung.", offer_clear_sub: "Dein lebenslanger Zugang gibt dir alles Wesentliche. Der Coach ist ein Extra, wann immer du willst.",
  card1_tag: "Lebenslanger Zugang · Einmalzahlung", card2_tag: "Premium-Option", card2_optional: "(optional)",
  card2_title: "GaimTime Coach", card2_price: "9,99 €", card2_feat: "Unbegrenzter persönlicher Coach", card2_feat2: "Motivation, Entscheidungen, Neuausrichtung", card2_note: "Aktivierbar in deinem Bereich nach dem Login",
  pricing_reassure: "GaimTime funktioniert zu 100% ohne den Coach. Der Coach ist eine Option, nie Pflicht.",
  listen_msg: "Anhören",
  faq_title: "Häufige Fragen",
  faq_q1: "Beschleunigt sich die Zeit wirklich?", faq_a1: "Nein 🙂 Es ist ein psychologisches Prinzip: deine angezeigte GaimTime-Uhr läuft schneller, was dein Gehirn antreibt, früher fertig zu werden. Die reale Zeit ändert sich nicht.",
  faq_q2: "Zahle ich nur einmal?", faq_a2: "Ja, 4,99€ lebenslang, eine einzige Zahlung. Der KI-Coach ist eine separate Option (9,99€/Monat), nie verpflichtend.",
  faq_q3: "Was ist der GaimTime Coach?", faq_a3: "Ein persönlicher KI-Coach, der dich motiviert und bei Entscheidungen hilft. Optional, in deinem Bereich aktivierbar.",
  faq_q4: "Funktioniert es auf dem Handy / offline?", faq_a4: "Ja, GaimTime ist eine installierbare App (PWA) auf deinem Handy, mit Offline-Zugang.",
  faq_q5: "Sind meine Daten privat?", faq_a5: "Ja, deine Daten bleiben privat und sicher; die Zahlung läuft über Stripe.",
  faq_q6: "Kann ich das Coach-Abo kündigen?", faq_a6: "Ja, jederzeit. Dein lebenslanger GaimTime-Zugang bleibt bestehen.",
  demo_title: "Sieh die Zeit, die du gewinnst", demo_sub: "Je mehr Minuten du pro Stunde gewinnst, desto früher endet dein Tag.", demo_classic: "Klassischer Tag", demo_withgaim: "Mit GaimTime", demo_saved: "{v} gewonnen 🎉",
  forgot_pw: "Passwort vergessen?", forgot_title: "Passwort zurücksetzen", forgot_desc: "Gib deine E-Mail ein und wir senden dir einen Link, um ein neues Passwort zu wählen.", forgot_submit: "Link senden", forgot_sent: "Falls ein Konto für diese E-Mail existiert, wurde gerade ein Link zum Zurücksetzen gesendet.", back_to_login: "← Zurück zur Anmeldung",
  reset_title: "Neues Passwort", reset_desc: "Wähle ein neues Passwort für dein Konto.", reset_new_pw: "Neues Passwort", reset_confirm_pw: "Passwort bestätigen", reset_submit: "Passwort aktualisieren", reset_success: "Passwort aktualisiert! Du kannst dich jetzt anmelden.", reset_mismatch: "Die Passwörter stimmen nicht überein.", reset_invalid_link: "Ungültiger oder abgelaufener Link. Bitte fordere einen neuen an.", reset_short: "Das Passwort muss mindestens 6 Zeichen haben.",
  edit_profile: "Profil bearbeiten", profile_title: "Mein Profil", profile_saved: "Profil aktualisiert", save: "Speichern", cancel: "Abbrechen",
  coach_cfg_btn: "Meinen Coach einrichten", coach_cfg_title: "Richte deinen Coach & Begleiter ein", coach_cfg_desc: "Alles optional — gestalte einen Coach, der zu dir passt. Jederzeit änderbar, für Arbeit, Leben oder anderes.",
  cfg_gender: "Geschlecht des Coaches", cfg_gender_m: "Mann", cfg_gender_f: "Frau",
  cfg_type: "Schwerpunkt des Coaches", type_work: "Arbeit", type_life: "Leben", type_love: "Liebe & Beziehungen", type_intimate: "Intimität", type_company: "Gesellschaft", type_other: "Andere",
  cfg_tone: "Ton", tone_direct: "Direkt & ehrlich", tone_soft: "Sanft & fürsorglich", tone_motiv: "Motivierend",
  cfg_nickname: "Wie soll dich der Coach nennen?", cfg_challenges: "Deine aktuellen Herausforderungen", cfg_values: "Was dir am wichtigsten ist", cfg_motivation: "Was dich motiviert",
  support_btn: "Support", tickets_title: "Support & Chat", tickets_desc: "Eine Frage? Schreib uns — wir antworten hier.", ticket_new: "Neue Nachricht", ticket_subject: "Betreff", ticket_message: "Deine Nachricht", ticket_send: "Senden", ticket_reply_ph: "Schreibe deine Antwort…", ticket_empty: "Noch keine Unterhaltung.", ticket_open: "Offen", ticket_closed: "Geschlossen", ticket_sent: "Nachricht gesendet!", ticket_back: "← Zurück", ticket_you: "Du", ticket_team: "GaimTime-Team", coach_daily_left: "Nachrichten heute übrig",
  coach_limit_title: "Du hast heute 150 Nachrichten erreicht 👏", coach_limit_desc: "Komm morgen wieder… oder mach jetzt mit einem Paket weiter.", coach_buy_pack: "Weiter · +150 Nachrichten · 2€", coach_bonus_label: "Bonus",
  err_generic: "Etwas ist schiefgelaufen. Bitte erneut versuchen.",
};

const it = {
  dev_rename: "Rinomina",
  dev_rename_ph: "Nome del dispositivo",
  push_blocks: "Sveglie dei blocchi di pianificazione",
  pv_pomodoro: "Pomodoro",
  pv_pomodoro_done: "Pomodoro aggiunto: 25 min focus / 5 min pausa",
  pv_sound: "Suono sveglia",
  pv_test: "Prova",
  snd_chime: "Carillon",
  snd_bell: "Campana",
  snd_beep: "Bip",
  snd_soft: "Morbido",
  banner_text: "Aggiungi GaimTime alla schermata Home",
  banner_btn: "Installa",
  ia_and_title: "Su Android (Chrome)",
  ia_and_1: "Apri il menu ⋮ di Chrome (in alto a destra).",
  ia_and_2: "Tocca 'Installa e crea collegamento'.",
  ia_and_3: "Tocca 'Installa' — fatto!",
  install_app: "Installa l'app",
  ia_title: "Installa GaimTime sul telefono",
  ia_desc: "Aggiungi GaimTime alla schermata Home: accesso rapido, schermo intero, come una vera app.",
  ia_install_btn: "Installa ora",
  ia_installed: "GaimTime è già installata su questo dispositivo 🎉",
  ia_ios_title: "Su iPhone / iPad (Safari)",
  ia_ios_1: "Tocca il pulsante Condividi in basso su Safari.",
  ia_ios_2: "Scegli 'Aggiungi a Home'.",
  ia_ios_3: "Tocca 'Aggiungi' — fatto!",
  ia_soon: "Screenshot in arrivo",
  pv_add: "Aggiungi un blocco",
  pv_label: "Nome",
  pv_type: "Tipo",
  pv_task: "Attività",
  pv_break: "Pausa",
  pv_start: "Inizio",
  pv_end: "Fine",
  pv_alarm_start: "Sveglia all'inizio",
  pv_alarm_end: "Sveglia alla fine",
  pv_free: "Libero",
  pv_save: "Aggiungi",
  pv_cancel: "Annulla",
  pv_delete: "Elimina",
  pv_invalid: "La fine deve essere dopo l'inizio, nella tua giornata.",
  pv_none: "Ancora nessun blocco. La tua giornata è libera — aggiungi il primo!",
  pv_fired: "È l'ora",
  pv_stop: "Ferma",
  lifetime_badge: "A vita",
  daystart_title: "La tua giornata GaimTime inizia! ⏳",
  daystart_body: "Si comincia — la tua giornata compressa è iniziata.",
  chpwd_menu: "Cambia password",
  chpwd_title: "Cambia password",
  chpwd_current: "Password attuale",
  chpwd_new: "Nuova password",
  chpwd_confirm: "Conferma nuova password",
  chpwd_save: "Salva",
  chpwd_success: "Password modificata con successo",
  chpwd_err_current: "Password attuale errata",
  chpwd_err_short: "Password troppo corta (min 6 caratteri)",
  chpwd_err_match: "Le password non corrispondono",
  chpwd_err_same: "La nuova password deve essere diversa",
  pv_reset: "Cancella tutto",
  menu_account: "Il mio account",
  menu_notif: "Notifiche",
  menu_help: "Guida / Aiuto",
  state_on: "Attivo",
  state_off: "Disattivo",
  ob_next: "Avanti",
  ob_back: "Indietro",
  ob_skip: "Salta",
  ob_done: "Capito!",
  ob_t1: "Benvenuto su GaimTime 👋",
  ob_d1: "Un rapido tour per sfruttare al meglio il tuo tempo. Bastano 20 secondi.",
  ob_t2: "I tuoi due orologi",
  ob_d2: "A sinistra l'ora reale. A destra il tuo GaimTime accelerato. La differenza è il tempo che guadagni.",
  ob_t3: "Imposta la tua giornata",
  ob_d3: "Scegli il tuo obiettivo di guadagno e l'orario di inizio. 'Apri Planning (24h)' organizza i tuoi blocchi.",
  ob_t4: "Il tuo menu account",
  ob_d4: "In alto a destra: notifiche, configurazione Coach IA, orologio nelle notifiche, i miei dispositivi, fatture e aiuto.",
  ob_t5: "Il tuo Coach IA",
  ob_d5: "Chatta col tuo Coach e Compagno quando vuoi — ti motiva come un amico stretto.",
  lc_title: "Orologio nelle notifiche",
  lc_on: "Orologio GaimTime attivato nelle tue notifiche",
  lc_off: "Orologio delle notifiche disattivato",
  lc_denied: "Consenti le notifiche per mostrare l'orologio",
  lc_unsupported: "Il tuo dispositivo non lo supporta",
  lc_gaim: "GaimTime",
  lc_gain: "Guadagno",
  devices_title: "I miei dispositivi",
  devices_desc: "Puoi usare fino a 2 dispositivi. Disconnettine uno per liberare un posto.",
  dev_this_device: "Questo dispositivo",
  devices_empty: "Nessun dispositivo attivo.",
  dev_limit_title: "Troppi dispositivi",
  dev_limit_desc: "Hai raggiunto il limite di 2 dispositivi. Disconnetti un dispositivo per continuare su questo.",
  dev_disconnect: "Disconnetti",
  dev_seen: "Attivo",
  hiw_audio_error: "Audio non disponibile al momento. Riprova tra poco.",
  upgrade_super_btn: "Passa a Super IA", plan_standard: "Coach Standard", plan_standard_desc: "Assistente IA veloce e naturale", plan_super: "Super IA", plan_super_desc: "L'IA più intelligente, più messaggi e voce al giorno", plan_super_tag: "Il migliore", activate_super: "Attiva Super IA", ps_success_super: "Super IA attivata!", tts_limit_reached: "Limite giornaliero di riproduzione vocale raggiunto.",
  my_invoices: "Le mie fatture",
  download: "Scarica",
  no_invoices: "Nessuna fattura ancora.",
  ctx_desc_general: "Chiacchierata libera: parla di ciò che vuoi, il tuo coach è qui per te.",
  ctx_desc_work: "Modalità lavoro: concentrazione ed efficienza — il tuo coach ti aiuta ad avanzare.",
  ctx_desc_company: "Solo compagnia: si chiacchiera, si ride, ti senti ascoltato.",
  ctx_desc_advice: "Ti serve un consiglio o aiuto per decidere? Racconta la tua situazione.",
  ctx_desc_relax: "Momento relax: stacca e liberati la mente.",
  ctx_desc_seduction: "Seduzione, flirt e intimità: atmosfera complice e sensuale (mai esplicita).",
  clear_thread: "Cancella conversazione",
  clear_thread_q: "Cancellare tutta questa conversazione?",
  clear_thread_desc: "Cancella solo i messaggi di questo tema. La tua nota di contesto rimane.",
  thread_cleared: "Conversazione cancellata",
  clear_confirm: "Cancella",
  note_btn: "Nota di contesto",
  note_title: "Contesto del tema (ricordato dall'IA)",
  note_ph: "Descrivi il tema, la tua situazione, ciò che l'IA deve sempre ricordare…",
  note_hint: "Resta in memoria anche se cancelli la conversazione. Non conta nei tuoi messaggi.",
  note_saved: "Contesto salvato",
  mic_hint: "Parla",
  mic_listening: "Ascolto… tocca per fermare",
  mic_unsupported: "L'input vocale non è supportato su questo browser",
  notif_settings: "Impostazioni notifiche",
  notif_settings_desc: "Scegli quali notifiche push ricevere.",
  push_morning: "Carica del mattino",
  push_midday: "Punto di mezzogiorno",
  push_coach: "Idea del Coach (IA)",
  push_evening: "Riepilogo serale",
  push_night: "Prepara domani",
  push_reengage: "Ci manchi",
  push_coach_note: "Richiede l'abbonamento Coach.",
  notif_prefs_saved: "Preferenze salvate",
  intent_label: "Di cosa hai bisogno oggi?",
  intent_none: "Generale",
  intent_work: "Lavoro serio",
  intent_company: "Compagnia",
  intent_advice: "Consiglio",
  intent_relax: "Rilassarsi",
  intent_seduction: "Seduzione",
  intent_saved: "Ricevuto — mi adatto alla tua giornata 👍",
  nav_login: "Accedi", nav_cta: "Attiva a vita", nav_logout: "Esci", nav_dashboard: "Dashboard", nav_admin: "Admin",
  hero_badge: "100% automatizzato · Psicologia positiva",
  hero_t1: "GaimTime: Crea il tuo Tempo Personale,", hero_hl: "vivi secondo le tue regole.", preview_explain: "Il tuo orologio GaimTime va più veloce → finisci la giornata prima e guadagni Tempo Personale.",
  hero_sub: "Non subire più il tempo che scorre. Che tu lavori, studi o organizzi le tue giornate, guadagna fino a 20 minuti all'ora e libera tempo per ciò che conta davvero.",
  hero_cta: "Attiva a vita", hero_cta_sub: "· 4,99 €",
  hero_trust: "Pagamento unico · Nessun abbonamento nascosto · Sicuro con Stripe",
  today_gain: "Oggi · Guadagno 10 min/h",
  f1_t: "Due orologi sincronizzati", f1_d: "La tua ora reale e il tuo Tempo GaimTime accelerato, aggiornati secondo per secondo.",
  f2_t: "Guadagno cumulato in tempo reale", f2_d: "Vedi il tempo che recuperi: fino a 1h20 in una giornata di 8h.",
  f3_t: "Pianificazione compressa 24h", f3_d: "Proietta i tuoi compiti in una giornata compressa e raggiungi prima i tuoi obiettivi.",
  comp_badge: "GaimTime Coach & Compagno", comp_t: "Un coach e compagno IA che ti conosce davvero.",
  comp_d: "Non un semplice chatbot. Un amico intimo e onesto che ti ascolta, ti consiglia e ti spinge ad agire. Amore, dubbi, progetti, paure — c'è, senza filtri.",
  comp_avail: "Disponibile con l'abbonamento Coach & Compagno (9,99 €/mese) dalla tua Dashboard.",
  chat_demo_q: "Domani devo prendere una grande decisione…", chat_demo_a: "Ok, respira. Raccontami tutto, lo risolveremo insieme. Cosa ti blocca davvero?",
  pricing_t: "Un pagamento. Accesso a vita.", pricing_sub: "Nessun abbonamento nascosto per l'app. Il Compagno IA resta opzionale.",
  price_life: "/ a vita", pf1: "Dashboard completa e orologi GaimTime", pf2: "Pianificazione compressa 24h", pf3: "Guadagna fino a 20 min/ora", pf4: "Aggiornamenti a vita",
  pricing_cta: "Attiva a vita",
  footer_contact: "Contatto", footer_cgv: "Termini", footer_legal: "Note legali",
  contact_title: "Contattaci", contact_desc: "Una domanda? Scrivici a questo indirizzo:", contact_copy_or: "Oppure apri la tua app email →", copied: "Email copiata!",
  gain: "Guadagno", objective_t: "Obiettivo di guadagno", objective_d: "Scegli i minuti che vuoi guadagnare ogni ora", minh: "min/h", start: "Inizio",
  real_clock: "Ora reale", gaim_clock: "Ora GaimTime", conv: "1h GaimTime = {n} min reali",
  gain_cumule: "Guadagno cumulato", day8: "Giornata (8h)", reset_counters: "Azzera contatori",
  traj_t: "Traiettoria di guadagno (minuti / ora di lavoro)", open_planning: "Apri Pianificazione (24h)", hide_planning: "Nascondi Pianificazione",
  coach_btn: "Parla col mio Coach & Compagno", timezone: "Fuso orario",
  planning_t: "Pianificazione compressa", add_task: "Aggiungi un compito…", reset: "Azzera", now: "adesso", real: "reale",
  coach_title: "GaimTime Coach & Compagno", coach_empty: "Ciao! Sono qui per te. Dimmi cosa ti frulla in testa oggi. 👋", coach_ph: "Scrivi al tuo coach…",
  create_acc: "Crea account", sign_in: "Accedi", firstname: "Nome", lastname: "Cognome", email: "Email", password: "Password", company: "Azienda (opzionale)",
  comp_intro: "Conosci il tuo Coach & Compagno", comp_intro_sub: "Opzionale — per un coach IA che ti conosce davvero.",
  situation_ph: "La tua situazione di vita (lavoro, famiglia…)", goals_ph: "I tuoi obiettivi attuali", interests_ph: "I tuoi interessi",
  login_submit: "Accedi", secure_pay: "Pagamento sicuro con Stripe",
  coachdlg_desc: "Sblocca il tuo coach e compagno di vita IA: un amico intimo e onesto, disponibile 24/7.", permonth: "/ mese", activate_coach: "Attiva Coach & Compagno — 9,99 €/mese",
  ps_checking: "Verifica del pagamento…", ps_wait_t: "Un attimo…", ps_success_life: "Accesso a vita attivato!", ps_success_coach: "Coach & Compagno attivato!",
  ps_done: "Fatto!", ps_oops: "Ops", ps_go_dash: "Vai alla Dashboard", ps_notfound: "Sessione di pagamento non trovata.", ps_slow: "Il pagamento richiede più tempo del previsto. Controlla la Dashboard tra poco.",
  lang_label: "Lingua", notif_on: "Notifiche attivate 🔔", notif_off: "Notifiche disattivate", tz_saved: "Fuso orario salvato",
  hiw_open: "Come funziona?",
  hiw_title: "E se la tua giornata finisse prima?",
  hiw_intro: "GaimTime accelera il tuo orologio. Vai più veloce del tempo reale, così la tua mente punta a una fine giornata più vicina — e finisci in anticipo.",
  hiw_s1_t: "Scegli il tuo guadagno", hiw_s1_d: "Decidi quanti minuti guadagnare all'ora: 5, 10 o 20 min.",
  hiw_s2_t: "Il tuo orologio GaimTime accelera", hiw_s2_d: "Mentre il tempo reale scorre normalmente, il tuo orologio GaimTime va avanti, secondo dopo secondo.",
  hiw_s3_t: "Finisci prima", hiw_s3_d: "Quando il tuo orologio GaimTime segna le 17, in realtà sono solo le 16:10. Hai guadagnato 50 minuti.",
  hiw_s4_t: "Pianifica i tuoi compiti con avvisi", hiw_s4_d: "Pianifica i tuoi compiti in ore GaimTime e ricevi un avviso con suoneria per ogni tappa.",
  hiw_example: "Esempio: con +10 min/ora, in una giornata di 8h la tua giornata GaimTime «finisce» mentre ti restano 1h20 di tempo reale. Questo vantaggio ti mantiene concentrato.",
  hiw_read: "Leggi", hiw_listen: "Ascolta", hiw_loading: "Generazione voce…", hiw_playing: "Riproduzione…",
  offer_clear_t: "Un'offerta chiara. Zero sorprese.", offer_clear_sub: "Il tuo accesso a vita ti dà tutto l'essenziale. Il Coach è un extra, quando vuoi.",
  card1_tag: "Accesso a vita · pagamento unico", card2_tag: "Opzione premium", card2_optional: "(opzionale)",
  card2_title: "GaimTime Coach", card2_price: "9,99 €", card2_feat: "Coach personale illimitato", card2_feat2: "Motivazione, decisioni, rifocalizzazione", card2_note: "Attivabile dal tuo spazio una volta connesso",
  pricing_reassure: "GaimTime funziona al 100% senza il Coach. Il Coach è un'opzione, mai obbligatorio.",
  listen_msg: "Ascolta",
  faq_title: "Domande frequenti",
  faq_q1: "Il tempo accelera davvero?", faq_a1: "No 🙂 È un principio di psicologia: il tuo orologio GaimTime mostrato va più veloce, spingendo il cervello a finire prima. Il tempo reale non cambia.",
  faq_q2: "Pago una sola volta?", faq_a2: "Sì, 4,99€ a vita, un unico pagamento. Il Coach IA è un'opzione a parte (9,99€/mese), mai obbligatoria.",
  faq_q3: "Cos'è il GaimTime Coach?", faq_a3: "Un coach personale IA che ti motiva e ti aiuta nelle decisioni. Opzionale, attivabile dal tuo spazio.",
  faq_q4: "Funziona su mobile / offline?", faq_a4: "Sì, GaimTime è un'app installabile (PWA) sul tuo telefono, con accesso offline.",
  faq_q5: "I miei dati sono privati?", faq_a5: "Sì, i tuoi dati restano privati e sicuri; il pagamento è gestito da Stripe.",
  faq_q6: "Posso annullare l'abbonamento Coach?", faq_a6: "Sì, quando vuoi. Il tuo accesso a vita GaimTime resta tuo.",
  demo_title: "Visualizza il tempo che guadagni", demo_sub: "Più minuti guadagni all'ora, prima finisce la tua giornata.", demo_classic: "Giornata classica", demo_withgaim: "Con GaimTime", demo_saved: "{v} guadagnate 🎉",
  forgot_pw: "Password dimenticata?", forgot_title: "Reimposta la password", forgot_desc: "Inserisci la tua email e ti invieremo un link per scegliere una nuova password.", forgot_submit: "Invia il link", forgot_sent: "Se esiste un account per questa email, abbiamo appena inviato un link per la reimpostazione.", back_to_login: "← Torna all'accesso",
  reset_title: "Nuova password", reset_desc: "Scegli una nuova password per il tuo account.", reset_new_pw: "Nuova password", reset_confirm_pw: "Conferma la password", reset_submit: "Aggiorna la password", reset_success: "Password aggiornata! Ora puoi accedere.", reset_mismatch: "Le password non coincidono.", reset_invalid_link: "Link non valido o scaduto. Richiedine uno nuovo.", reset_short: "La password deve avere almeno 6 caratteri.",
  edit_profile: "Modifica il profilo", profile_title: "Il mio profilo", profile_saved: "Profilo aggiornato", save: "Salva", cancel: "Annulla",
  coach_cfg_btn: "Configura il mio Coach", coach_cfg_title: "Configura il tuo Coach e Compagno", coach_cfg_desc: "Tutto opzionale — crea un coach che ti somiglia. Modificabile in qualsiasi momento, per lavoro, vita o altro.",
  cfg_gender: "Genere del coach", cfg_gender_m: "Uomo", cfg_gender_f: "Donna",
  cfg_type: "Specialità del coach", type_work: "Lavoro", type_life: "Vita", type_love: "Amore e relazioni", type_intimate: "Intimità", type_company: "Compagnia", type_other: "Altro",
  cfg_tone: "Tono", tone_direct: "Diretto e sincero", tone_soft: "Dolce e premuroso", tone_motiv: "Motivante",
  cfg_nickname: "Come deve chiamarti il coach?", cfg_challenges: "Le tue sfide o blocchi attuali", cfg_values: "Ciò che conta di più per te", cfg_motivation: "Ciò che ti motiva",
  support_btn: "Supporto", tickets_title: "Supporto e Chat", tickets_desc: "Una domanda? Scrivici, ti rispondiamo qui.", ticket_new: "Nuovo messaggio", ticket_subject: "Oggetto", ticket_message: "Il tuo messaggio", ticket_send: "Invia", ticket_reply_ph: "Scrivi la tua risposta…", ticket_empty: "Ancora nessuna conversazione.", ticket_open: "Aperto", ticket_closed: "Chiuso", ticket_sent: "Messaggio inviato!", ticket_back: "← Indietro", ticket_you: "Tu", ticket_team: "Team GaimTime", coach_daily_left: "messaggi rimasti oggi",
  coach_limit_title: "Hai raggiunto 150 messaggi oggi 👏", coach_limit_desc: "Torna domani… o continua subito con un pacchetto.", coach_buy_pack: "Continua · +150 messaggi · 2€", coach_bonus_label: "bonus",
  err_generic: "Qualcosa è andato storto. Riprova.",
};

const pt = {
  dev_rename: "Renomear",
  dev_rename_ph: "Nome do dispositivo",
  push_blocks: "Alarmes dos blocos do planeamento",
  pv_pomodoro: "Pomodoro",
  pv_pomodoro_done: "Pomodoro adicionado: 25 min foco / 5 min pausa",
  pv_sound: "Som do alarme",
  pv_test: "Testar",
  snd_chime: "Carrilhão",
  snd_bell: "Sino",
  snd_beep: "Bip",
  snd_soft: "Suave",
  banner_text: "Adiciona o GaimTime ao ecrã inicial",
  banner_btn: "Instalar",
  ia_and_title: "No Android (Chrome)",
  ia_and_1: "Abre o menu ⋮ do Chrome (canto superior direito).",
  ia_and_2: "Toca em 'Instalar e criar atalho'.",
  ia_and_3: "Toca em 'Instalar' — pronto!",
  install_app: "Instalar a app",
  ia_title: "Instala o GaimTime no teu telemóvel",
  ia_desc: "Adiciona o GaimTime ao ecrã inicial: acesso rápido, ecrã inteiro, como uma app real.",
  ia_install_btn: "Instalar agora",
  ia_installed: "O GaimTime já está instalado neste dispositivo 🎉",
  ia_ios_title: "No iPhone / iPad (Safari)",
  ia_ios_1: "Toca no botão Partilhar no fundo do Safari.",
  ia_ios_2: "Escolhe 'Adicionar ao ecrã principal'.",
  ia_ios_3: "Toca em 'Adicionar' — pronto!",
  ia_soon: "Captura em breve",
  pv_add: "Adicionar um bloco",
  pv_label: "Nome",
  pv_type: "Tipo",
  pv_task: "Tarefa",
  pv_break: "Pausa",
  pv_start: "Início",
  pv_end: "Fim",
  pv_alarm_start: "Alarme no início",
  pv_alarm_end: "Alarme no fim",
  pv_free: "Livre",
  pv_save: "Adicionar",
  pv_cancel: "Cancelar",
  pv_delete: "Eliminar",
  pv_invalid: "O fim deve ser após o início, dentro do teu dia.",
  pv_none: "Ainda sem blocos. O teu dia está livre — adiciona o primeiro!",
  pv_fired: "Está na hora",
  pv_stop: "Parar",
  lifetime_badge: "Vitalício",
  daystart_title: "O teu dia GaimTime começa! ⏳",
  daystart_body: "Vamos a isto — o teu dia comprimido começou.",
  chpwd_menu: "Alterar palavra-passe",
  chpwd_title: "Alterar palavra-passe",
  chpwd_current: "Palavra-passe atual",
  chpwd_new: "Nova palavra-passe",
  chpwd_confirm: "Confirmar nova palavra-passe",
  chpwd_save: "Guardar",
  chpwd_success: "Palavra-passe alterada com sucesso",
  chpwd_err_current: "Palavra-passe atual incorreta",
  chpwd_err_short: "Palavra-passe muito curta (mín 6 carateres)",
  chpwd_err_match: "As palavras-passe não coincidem",
  chpwd_err_same: "A nova palavra-passe deve ser diferente",
  pv_reset: "Limpar tudo",
  menu_account: "A minha conta",
  menu_notif: "Notificações",
  menu_help: "Guia / Ajuda",
  state_on: "Ativo",
  state_off: "Inativo",
  ob_next: "Seguinte",
  ob_back: "Voltar",
  ob_skip: "Ignorar",
  ob_done: "Percebi!",
  ob_t1: "Bem-vindo ao GaimTime 👋",
  ob_d1: "Uma visita rápida para aproveitar o teu tempo. Demora 20 segundos.",
  ob_t2: "Os teus dois relógios",
  ob_d2: "À esquerda, a hora real. À direita, o teu GaimTime acelerado. A diferença é o tempo que ganhas.",
  ob_t3: "Configura o teu dia",
  ob_d3: "Escolhe o teu objetivo de ganho e a hora de início. 'Abrir Planning (24h)' organiza os teus blocos.",
  ob_t4: "O teu menu de conta",
  ob_d4: "Canto superior direito: notificações, configuração do Coach IA, relógio nas notificações, dispositivos, faturas e ajuda.",
  ob_t5: "O teu Coach IA",
  ob_d5: "Fala com o teu Coach e Companheiro quando quiseres — motiva-te como um amigo próximo.",
  lc_title: "Relógio nas notificações",
  lc_on: "Relógio GaimTime ativado nas tuas notificações",
  lc_off: "Relógio das notificações desativado",
  lc_denied: "Permite as notificações para mostrar o relógio",
  lc_unsupported: "O teu dispositivo não suporta isto",
  lc_gaim: "GaimTime",
  lc_gain: "Ganho",
  devices_title: "Os meus dispositivos",
  devices_desc: "Podes usar até 2 dispositivos. Desliga um para libertar espaço.",
  dev_this_device: "Este dispositivo",
  devices_empty: "Nenhum dispositivo ativo.",
  dev_limit_title: "Demasiados dispositivos",
  dev_limit_desc: "Atingiste o limite de 2 dispositivos. Desliga um para continuar neste.",
  dev_disconnect: "Desligar",
  dev_seen: "Ativo",
  hiw_audio_error: "Áudio indisponível de momento. Tenta novamente daqui a pouco.",
  upgrade_super_btn: "Mudar para Super IA", plan_standard: "Coach Padrão", plan_standard_desc: "Assistente de IA rápido e natural", plan_super: "Super IA", plan_super_desc: "A IA mais inteligente, mais mensagens e voz por dia", plan_super_tag: "O melhor", activate_super: "Ativar Super IA", ps_success_super: "Super IA ativada!", tts_limit_reached: "Limite diário de leitura por voz atingido.",
  my_invoices: "As minhas faturas",
  download: "Descarregar",
  no_invoices: "Ainda sem faturas.",
  ctx_desc_general: "Conversa livre: fala do que quiseres, o teu coach está aqui para ti.",
  ctx_desc_work: "Modo trabalho: foco e eficiência — o teu coach ajuda-te a avançar.",
  ctx_desc_company: "Só companhia: conversamos, rimos, sentes-te ouvido.",
  ctx_desc_advice: "Precisas de um conselho ou ajuda para decidir? Expõe a tua situação.",
  ctx_desc_relax: "Momento de descontração: desliga e areja a mente.",
  ctx_desc_seduction: "Sedução, flerte e intimidade: ambiente cúmplice e sensual (nunca explícito).",
  clear_thread: "Apagar conversa",
  clear_thread_q: "Apagar toda esta conversa?",
  clear_thread_desc: "Apaga apenas as mensagens deste tema. A tua nota de contexto fica guardada.",
  thread_cleared: "Conversa apagada",
  clear_confirm: "Apagar",
  note_btn: "Nota de contexto",
  note_title: "Contexto do tema (memorizado pela IA)",
  note_ph: "Descreve o tema, a tua situação, o que a IA deve lembrar sempre…",
  note_hint: "Fica guardado mesmo que apagues a conversa. Não conta nas tuas mensagens.",
  note_saved: "Contexto guardado",
  mic_hint: "Falar",
  mic_listening: "A ouvir… toca para parar",
  mic_unsupported: "A entrada de voz não é suportada neste navegador",
  notif_settings: "Definições de notificações",
  notif_settings_desc: "Escolhe que notificações push recebes.",
  push_morning: "Impulso da manhã",
  push_midday: "Ponto do meio-dia",
  push_coach: "Ideia do Coach (IA)",
  push_evening: "Resumo da noite",
  push_night: "Preparar amanhã",
  push_reengage: "Temos saudades tuas",
  push_coach_note: "Requer a subscrição Coach.",
  notif_prefs_saved: "Preferências guardadas",
  intent_label: "Do que precisas hoje?",
  intent_none: "Geral",
  intent_work: "Trabalho sério",
  intent_company: "Companhia",
  intent_advice: "Conselho",
  intent_relax: "Descontrair",
  intent_seduction: "Sedução",
  intent_saved: "Anotado — adapto-me ao teu dia 👍",
  nav_login: "Entrar", nav_cta: "Ativar vitalício", nav_logout: "Sair", nav_dashboard: "Painel", nav_admin: "Admin",
  hero_badge: "100% automatizado · Psicologia positiva",
  hero_t1: "GaimTime: Crie o seu Tempo Pessoal,", hero_hl: "viva segundo as suas regras.", preview_explain: "O teu relógio GaimTime anda mais depressa → terminas o teu dia mais cedo e ganhas Tempo Pessoal.",
  hero_sub: "Pare de deixar o tempo escapar. Quer trabalhes, estudes ou organizes os teus dias, ganha até 20 minutos por hora e liberta tempo para o que realmente importa.",
  hero_cta: "Ativar vitalício", hero_cta_sub: "· 4,99 €",
  hero_trust: "Pagamento único · Sem assinatura oculta · Seguro com Stripe",
  today_gain: "Hoje · Ganho 10 min/h",
  f1_t: "Dois relógios sincronizados", f1_d: "Sua hora real e seu Tempo GaimTime acelerado, atualizados segundo a segundo.",
  f2_t: "Ganho acumulado ao vivo", f2_d: "Veja o tempo que você recupera: até 1h20 num dia de 8h.",
  f3_t: "Planejamento comprimido 24h", f3_d: "Projete suas tarefas num dia comprimido e alcance suas metas mais cedo.",
  comp_badge: "GaimTime Coach & Companheiro", comp_t: "Um coach e companheiro IA que realmente conhece você.",
  comp_d: "Não um simples chatbot. Um amigo íntimo e honesto que ouve, aconselha e te empurra a agir. Amor, dúvidas, projetos, medos — está lá, sem filtro.",
  comp_avail: "Disponível na assinatura Coach & Companheiro (9,99 €/mês) no seu Painel.",
  chat_demo_q: "Tenho uma grande decisão para tomar amanhã…", chat_demo_a: "Ok, respira. Conta tudo, vamos resolver juntos. O que realmente te bloqueia?",
  pricing_t: "Um pagamento. Acesso vitalício.", pricing_sub: "Sem assinatura oculta para o app. O Companheiro IA é opcional.",
  price_life: "/ vitalício", pf1: "Painel completo e relógios GaimTime", pf2: "Planejamento comprimido 24h", pf3: "Ganhe até 20 min/hora", pf4: "Atualizações vitalícias",
  pricing_cta: "Ativar vitalício",
  footer_contact: "Contato", footer_cgv: "Termos", footer_legal: "Aviso legal",
  contact_title: "Fale conosco", contact_desc: "Uma dúvida? Escreva para este endereço:", contact_copy_or: "Ou abra seu app de e-mail →", copied: "E-mail copiado!",
  gain: "Ganho", objective_t: "Objetivo de ganho", objective_d: "Escolhe os minutos que queres ganhar por hora", minh: "min/h", start: "Início",
  real_clock: "Hora real", gaim_clock: "Hora GaimTime", conv: "1h GaimTime = {n} min reais",
  gain_cumule: "Ganho acumulado", day8: "Dia (8h)", reset_counters: "Zerar contadores",
  traj_t: "Trajetória de ganho (minutos / hora de trabalho)", open_planning: "Abrir Planejamento (24h)", hide_planning: "Ocultar Planejamento",
  coach_btn: "Falar com meu Coach & Companheiro", timezone: "Fuso horário",
  planning_t: "Planejamento comprimido", add_task: "Adicionar tarefa…", reset: "Zerar", now: "agora", real: "real",
  coach_title: "GaimTime Coach & Companheiro", coach_empty: "Oi! Estou aqui por você. Diz o que está passando na sua cabeça hoje. 👋", coach_ph: "Escreva ao seu coach…",
  create_acc: "Criar conta", sign_in: "Entrar", firstname: "Nome", lastname: "Sobrenome", email: "E-mail", password: "Senha", company: "Empresa (opcional)",
  comp_intro: "Conheça seu Coach & Companheiro", comp_intro_sub: "Opcional — para um coach IA que conhece você de verdade.",
  situation_ph: "Sua situação de vida (trabalho, família…)", goals_ph: "Seus objetivos atuais", interests_ph: "Seus interesses",
  login_submit: "Entrar", secure_pay: "Pagamento seguro com Stripe",
  coachdlg_desc: "Desbloqueie seu coach e companheiro de vida IA: um amigo íntimo e honesto, disponível 24/7.", permonth: "/ mês", activate_coach: "Ativar Coach & Companheiro — 9,99 €/mês",
  ps_checking: "Verificando seu pagamento…", ps_wait_t: "Um momento…", ps_success_life: "Acesso vitalício ativado!", ps_success_coach: "Coach & Companheiro ativado!",
  ps_done: "Pronto!", ps_oops: "Ops", ps_go_dash: "Ir ao Painel", ps_notfound: "Sessão de pagamento não encontrada.", ps_slow: "O pagamento está demorando mais que o previsto. Verifique seu Painel em breve.",
  lang_label: "Idioma", notif_on: "Notificações ativadas 🔔", notif_off: "Notificações desativadas", tz_saved: "Fuso horário salvo",
  hiw_open: "Como funciona?",
  hiw_title: "E se o teu dia acabasse mais cedo?",
  hiw_intro: "O GaimTime acelera o teu relógio. Avanças mais rápido que o tempo real, por isso o teu cérebro mira num fim de dia mais próximo — e terminas adiantado.",
  hiw_s1_t: "Escolhe o teu ganho", hiw_s1_d: "Decides quantos minutos ganhar por hora: 5, 10, 15 ou 20 min.",
  hiw_s2_t: "O teu relógio GaimTime acelera", hiw_s2_d: "Enquanto o tempo real avança normalmente, o teu relógio GaimTime ganha vantagem, segundo a segundo.",
  hiw_s3_t: "Terminas mais cedo", hiw_s3_d: "Quando o teu relógio GaimTime marca 17h, na realidade são apenas 16h10. Ganhaste 50 minutos.",
  hiw_s4_t: "Planeia as tuas tarefas com alertas", hiw_s4_d: "Agenda as tuas tarefas em hora GaimTime e recebe um alerta com toque para cada etapa.",
  hiw_example: "Exemplo: com +10 min/hora, num dia de 8h o teu dia GaimTime «termina» quando ainda te restam 1h20 de tempo real. Essa vantagem mantém-te focado.",
  hiw_read: "Ler", hiw_listen: "Ouvir", hiw_loading: "A gerar a voz…", hiw_playing: "A reproduzir…",
  offer_clear_t: "Uma oferta clara. Zero surpresas.", offer_clear_sub: "O teu acesso vitalício dá-te tudo o essencial. O Coach é um extra, quando quiseres.",
  card1_tag: "Acesso vitalício · pagamento único", card2_tag: "Opção premium", card2_optional: "(opcional)",
  card2_title: "GaimTime Coach", card2_price: "9,99 €", card2_feat: "Coach pessoal ilimitado", card2_feat2: "Motivação, decisões, reorientação", card2_note: "Ativável no teu espaço depois de entrar",
  pricing_reassure: "O GaimTime funciona a 100% sem o Coach. O Coach é uma opção, nunca obrigatório.",
  listen_msg: "Ouvir",
  faq_title: "Perguntas frequentes",
  faq_q1: "O tempo acelera mesmo?", faq_a1: "Não 🙂 É um princípio de psicologia: o teu relógio GaimTime mostrado avança mais rápido, o que leva o teu cérebro a terminar mais cedo. O tempo real não muda.",
  faq_q2: "Pago uma única vez?", faq_a2: "Sim, 4,99€ vitalício, um único pagamento. O Coach IA é uma opção à parte (9,99€/mês), nunca obrigatória.",
  faq_q3: "O que é o GaimTime Coach?", faq_a3: "Um coach pessoal com IA que te motiva e ajuda nas tuas decisões. Opcional, ativável no teu espaço.",
  faq_q4: "Funciona no telemóvel / offline?", faq_a4: "Sim, o GaimTime é uma app instalável (PWA) no teu telemóvel, com acesso offline.",
  faq_q5: "Os meus dados são privados?", faq_a5: "Sim, os teus dados são privados e seguros; o pagamento é feito via Stripe.",
  faq_q6: "Posso cancelar a subscrição do Coach?", faq_a6: "Sim, quando quiseres. O teu acesso vitalício GaimTime continua teu.",
  demo_title: "Vê o tempo que ganhas", demo_sub: "Quantos mais minutos ganhas por hora, mais cedo termina o teu dia.", demo_classic: "Dia clássico", demo_withgaim: "Com GaimTime", demo_saved: "{v} ganhas 🎉",
  forgot_pw: "Esqueceste a palavra-passe?", forgot_title: "Redefinir a palavra-passe", forgot_desc: "Insere o teu email e enviaremos um link para escolheres uma nova palavra-passe.", forgot_submit: "Enviar o link", forgot_sent: "Se existir uma conta para este email, acabámos de enviar um link de redefinição.", back_to_login: "← Voltar ao início de sessão",
  reset_title: "Nova palavra-passe", reset_desc: "Escolhe uma nova palavra-passe para a tua conta.", reset_new_pw: "Nova palavra-passe", reset_confirm_pw: "Confirma a palavra-passe", reset_submit: "Atualizar a palavra-passe", reset_success: "Palavra-passe atualizada! Já podes iniciar sessão.", reset_mismatch: "As palavras-passe não coincidem.", reset_invalid_link: "Link inválido ou expirado. Pede um novo.", reset_short: "A palavra-passe deve ter pelo menos 6 caracteres.",
  edit_profile: "Editar o meu perfil", profile_title: "O meu perfil", profile_saved: "Perfil atualizado", save: "Guardar", cancel: "Cancelar",
  coach_cfg_btn: "Configurar o meu Coach", coach_cfg_title: "Configura o teu Coach e Companheiro", coach_cfg_desc: "Tudo opcional — cria um coach que combina contigo. Muda quando quiseres, para trabalho, vida ou outro.",
  cfg_gender: "Género do coach", cfg_gender_m: "Homem", cfg_gender_f: "Mulher",
  cfg_type: "Especialidade do coach", type_work: "Trabalho", type_life: "Vida", type_love: "Amor e relações", type_intimate: "Intimidade", type_company: "Companhia", type_other: "Outro",
  cfg_tone: "Tom", tone_direct: "Direto e sincero", tone_soft: "Suave e atencioso", tone_motiv: "Motivador",
  cfg_nickname: "Como o coach te deve chamar?", cfg_challenges: "Os teus desafios ou bloqueios atuais", cfg_values: "O que mais importa para ti", cfg_motivation: "O que te motiva",
  support_btn: "Suporte", tickets_title: "Suporte e Chat", tickets_desc: "Uma pergunta? Escreve-nos, respondemos aqui.", ticket_new: "Nova mensagem", ticket_subject: "Assunto", ticket_message: "A tua mensagem", ticket_send: "Enviar", ticket_reply_ph: "Escreve a tua resposta…", ticket_empty: "Ainda sem conversas.", ticket_open: "Aberto", ticket_closed: "Fechado", ticket_sent: "Mensagem enviada!", ticket_back: "← Voltar", ticket_you: "Tu", ticket_team: "Equipa GaimTime", coach_daily_left: "mensagens restantes hoje",
  coach_limit_title: "Atingiste 150 mensagens hoje 👏", coach_limit_desc: "Volta amanhã… ou continua já com um pacote.", coach_buy_pack: "Continuar · +150 mensagens · 2€", coach_bonus_label: "bónus",
  err_generic: "Algo correu mal. Tenta novamente.",
};

const ru = {
  dev_rename: "Переименовать",
  dev_rename_ph: "Имя устройства",
  push_blocks: "Будильники блоков планирования",
  pv_pomodoro: "Помодоро",
  pv_pomodoro_done: "Помодоро добавлен: 25 мин фокус / 5 мин перерыв",
  pv_sound: "Звук сигнала",
  pv_test: "Тест",
  snd_chime: "Перезвон",
  snd_bell: "Колокол",
  snd_beep: "Бип",
  snd_soft: "Мягкий",
  banner_text: "Добавьте GaimTime на главный экран",
  banner_btn: "Установить",
  ia_and_title: "На Android (Chrome)",
  ia_and_1: "Откройте меню ⋮ Chrome (вверху справа).",
  ia_and_2: "Нажмите «Установить и создать ярлык».",
  ia_and_3: "Нажмите «Установить» — готово!",
  install_app: "Установить приложение",
  ia_title: "Установите GaimTime на телефон",
  ia_desc: "Добавьте GaimTime на главный экран: быстрый доступ, полный экран, как настоящее приложение.",
  ia_install_btn: "Установить сейчас",
  ia_installed: "GaimTime уже установлен на этом устройстве 🎉",
  ia_ios_title: "На iPhone / iPad (Safari)",
  ia_ios_1: "Нажмите кнопку «Поделиться» внизу Safari.",
  ia_ios_2: "Выберите «На экран Домой».",
  ia_ios_3: "Нажмите «Добавить» — готово!",
  ia_soon: "Скриншот скоро",
  pv_add: "Добавить блок",
  pv_label: "Название",
  pv_type: "Тип",
  pv_task: "Задача",
  pv_break: "Перерыв",
  pv_start: "Начало",
  pv_end: "Конец",
  pv_alarm_start: "Сигнал в начале",
  pv_alarm_end: "Сигнал в конце",
  pv_free: "Свободно",
  pv_save: "Добавить",
  pv_cancel: "Отмена",
  pv_delete: "Удалить",
  pv_invalid: "Конец должен быть после начала, в пределах дня.",
  pv_none: "Пока нет блоков. День свободен — добавьте первый!",
  pv_fired: "Время вышло",
  pv_stop: "Остановить",
  lifetime_badge: "Навсегда",
  daystart_title: "Ваш день GaimTime начинается! ⏳",
  daystart_body: "Начали — ваш сжатый день стартовал.",
  chpwd_menu: "Сменить пароль",
  chpwd_title: "Смена пароля",
  chpwd_current: "Текущий пароль",
  chpwd_new: "Новый пароль",
  chpwd_confirm: "Подтвердите новый пароль",
  chpwd_save: "Сохранить",
  chpwd_success: "Пароль успешно изменён",
  chpwd_err_current: "Текущий пароль неверный",
  chpwd_err_short: "Пароль слишком короткий (мин 6 символов)",
  chpwd_err_match: "Пароли не совпадают",
  chpwd_err_same: "Новый пароль должен отличаться",
  pv_reset: "Очистить всё",
  menu_account: "Мой аккаунт",
  menu_notif: "Уведомления",
  menu_help: "Руководство / Помощь",
  state_on: "Вкл",
  state_off: "Выкл",
  ob_next: "Далее",
  ob_back: "Назад",
  ob_skip: "Пропустить",
  ob_done: "Понятно!",
  ob_t1: "Добро пожаловать в GaimTime 👋",
  ob_d1: "Краткий тур, чтобы использовать время по максимуму. Займёт 20 секунд.",
  ob_t2: "Ваши двое часов",
  ob_d2: "Слева — реальное время. Справа — ускоренное GaimTime. Разница — это выигранное время.",
  ob_t3: "Настройте свой день",
  ob_d3: "Выберите цель по выигрышу и время начала. «Открыть план (24ч)» организует ваши блоки.",
  ob_t4: "Меню аккаунта",
  ob_d4: "Вверху справа: уведомления, настройка ИИ-коуча, часы в уведомлениях, мои устройства, счета и помощь.",
  ob_t5: "Ваш ИИ-коуч",
  ob_d5: "Общайтесь с коучем-компаньоном в любое время — он мотивирует, как близкий друг.",
  lc_title: "Часы в уведомлениях",
  lc_on: "Часы GaimTime включены в уведомлениях",
  lc_off: "Часы в уведомлениях отключены",
  lc_denied: "Разрешите уведомления, чтобы показать часы",
  lc_unsupported: "Ваше устройство это не поддерживает",
  lc_gaim: "GaimTime",
  lc_gain: "Выигрыш",
  devices_title: "Мои устройства",
  devices_desc: "Можно использовать до 2 устройств. Отключите одно, чтобы освободить место.",
  dev_this_device: "Это устройство",
  devices_empty: "Нет активных устройств.",
  dev_limit_title: "Слишком много устройств",
  dev_limit_desc: "Достигнут лимит в 2 устройства. Отключите одно, чтобы продолжить на этом.",
  dev_disconnect: "Отключить",
  dev_seen: "Активно",
  hiw_audio_error: "Аудио сейчас недоступно. Повторите попытку чуть позже.",
  upgrade_super_btn: "Перейти на Супер ИИ", plan_standard: "Стандартный коуч", plan_standard_desc: "Быстрый и естественный ИИ-ассистент", plan_super: "Супер ИИ", plan_super_desc: "Самый умный ИИ, больше сообщений и голоса в день", plan_super_tag: "Лучший", activate_super: "Активировать Супер ИИ", ps_success_super: "Супер ИИ активирован!", tts_limit_reached: "Достигнут дневной лимит озвучивания.",
  my_invoices: "Мои счета",
  download: "Скачать",
  no_invoices: "Пока нет счетов.",
  ctx_desc_general: "Свободный разговор: говори о чём угодно, коуч рядом.",
  ctx_desc_work: "Режим работы: концентрация и эффективность — коуч помогает двигаться вперёд.",
  ctx_desc_company: "Просто общение: болтаем, смеёмся, тебя слушают.",
  ctx_desc_advice: "Нужен совет или помощь с решением? Опиши свою ситуацию.",
  ctx_desc_relax: "Время расслабиться: отдохни и отвлекись.",
  ctx_desc_seduction: "Флирт, соблазнение и близость: игривая и чувственная атмосфера (без откровенности).",
  clear_thread: "Очистить диалог",
  clear_thread_q: "Очистить весь этот диалог?",
  clear_thread_desc: "Удаляются только сообщения этой темы. Ваша заметка контекста сохраняется.",
  thread_cleared: "Диалог очищен",
  clear_confirm: "Очистить",
  note_btn: "Заметка контекста",
  note_title: "Контекст темы (запоминается ИИ)",
  note_ph: "Опишите тему, вашу ситуацию, что ИИ должен всегда помнить…",
  note_hint: "Сохраняется, даже если вы очистите диалог. Не считается в ваших сообщениях.",
  note_saved: "Контекст сохранён",
  mic_hint: "Говорить",
  mic_listening: "Слушаю… нажмите, чтобы остановить",
  mic_unsupported: "Голосовой ввод не поддерживается в этом браузере",
  notif_settings: "Настройки уведомлений",
  notif_settings_desc: "Выберите, какие push-уведомления получать.",
  push_morning: "Утренний заряд",
  push_midday: "Полуденная сверка",
  push_coach: "Идея коуча (ИИ)",
  push_evening: "Итоги вечера",
  push_night: "Подготовка к завтра",
  push_reengage: "Мы скучаем по вам",
  push_coach_note: "Требуется подписка Коуч.",
  notif_prefs_saved: "Настройки сохранены",
  intent_label: "Что вам нужно сегодня?",
  intent_none: "Общее",
  intent_work: "Серьёзная работа",
  intent_company: "Общение",
  intent_advice: "Совет",
  intent_relax: "Расслабиться",
  intent_seduction: "Флирт",
  intent_saved: "Понял — подстроюсь под ваш день 👍",
  nav_login: "Войти", nav_cta: "Активировать навсегда", nav_logout: "Выйти", nav_dashboard: "Панель", nav_admin: "Админ",
  hero_badge: "100% автоматизировано · Позитивная психология",
  hero_t1: "GaimTime: Создайте своё Личное Время,", hero_hl: "живите по своим правилам.", preview_explain: "Ваши часы GaimTime идут быстрее → вы заканчиваете день раньше и получаете Личное Время.",
  hero_sub: "Хватит терять время впустую. Работаете, учитесь или планируете свои дни — выигрывайте до 20 минут в час и освобождайте время для действительно важного.",
  hero_cta: "Активировать навсегда", hero_cta_sub: "· 4,99 €",
  hero_trust: "Разовый платёж · Без скрытой подписки · Защищено Stripe",
  today_gain: "Сегодня · Выигрыш 10 мин/ч",
  f1_t: "Двое синхронных часов", f1_d: "Ваше реальное время и ускоренное GaimTime, обновляются каждую секунду.",
  f2_t: "Накопленный выигрыш вживую", f2_d: "Смотрите, сколько времени вы возвращаете: до 1ч20м за 8-часовой день.",
  f3_t: "Сжатое планирование 24ч", f3_d: "Проецируйте задачи в сжатый день и достигайте целей раньше.",
  comp_badge: "GaimTime Коуч и Компаньон", comp_t: "ИИ-коуч и компаньон, который вас по-настоящему знает.",
  comp_d: "Не просто чат-бот. Близкий, честный друг, который слушает, советует и подталкивает к действию. Любовь, сомнения, планы, страхи — он рядом, без фильтров.",
  comp_avail: "Доступно по подписке Коуч и Компаньон (9,99 €/мес) в вашей Панели.",
  chat_demo_q: "Завтра мне нужно принять важное решение…", chat_demo_a: "Ок, дыши. Расскажи всё, разберёмся вместе. Что тебя на самом деле останавливает?",
  pricing_t: "Один платёж. Пожизненный доступ.", pricing_sub: "Никакой скрытой подписки для приложения. ИИ-компаньон опционален.",
  price_life: "/ навсегда", pf1: "Полная панель и часы GaimTime", pf2: "Сжатое планирование 24ч", pf3: "Экономьте до 20 мин/час", pf4: "Пожизненные обновления",
  pricing_cta: "Активировать навсегда",
  footer_contact: "Контакт", footer_cgv: "Условия", footer_legal: "Правовая информация",
  contact_title: "Свяжитесь с нами", contact_desc: "Вопрос? Напишите нам на этот адрес:", contact_copy_or: "Или откройте почтовое приложение →", copied: "Email скопирован!",
  gain: "Выигрыш", objective_t: "Цель выигрыша", objective_d: "Выбери минуты, которые хочешь выигрывать каждый час", minh: "мин/ч", start: "Начало",
  real_clock: "Реальное время", gaim_clock: "Час GaimTime", conv: "1ч GaimTime = {n} реальных мин",
  gain_cumule: "Накопленный выигрыш", day8: "День (8ч)", reset_counters: "Сбросить счётчики",
  traj_t: "Траектория выигрыша (минуты / час работы)", open_planning: "Открыть планирование (24ч)", hide_planning: "Скрыть планирование",
  coach_btn: "Поговорить с Коучем и Компаньоном", timezone: "Часовой пояс",
  planning_t: "Сжатое планирование", add_task: "Добавить задачу…", reset: "Сброс", now: "сейчас", real: "реал.",
  coach_title: "GaimTime Коуч и Компаньон", coach_empty: "Привет! Я здесь ради тебя. Расскажи, что у тебя на уме сегодня. 👋", coach_ph: "Напиши своему коучу…",
  create_acc: "Создать аккаунт", sign_in: "Войти", firstname: "Имя", lastname: "Фамилия", email: "Email", password: "Пароль", company: "Компания (необяз.)",
  comp_intro: "Познакомьтесь с Коучем и Компаньоном", comp_intro_sub: "Опционально — для ИИ-коуча, который вас знает.",
  situation_ph: "Твоя жизненная ситуация (работа, семья…)", goals_ph: "Твои текущие цели", interests_ph: "Твои интересы",
  login_submit: "Войти", secure_pay: "Безопасная оплата через Stripe",
  coachdlg_desc: "Откройте ИИ-коуча и компаньона: близкого, честного друга, доступного 24/7.", permonth: "/ мес", activate_coach: "Активировать Коуча и Компаньона — 9,99 €/мес",
  ps_checking: "Проверяем ваш платёж…", ps_wait_t: "Один момент…", ps_success_life: "Пожизненный доступ активирован!", ps_success_coach: "Коуч и Компаньон активированы!",
  ps_done: "Готово!", ps_oops: "Упс", ps_go_dash: "В Панель", ps_notfound: "Платёжная сессия не найдена.", ps_slow: "Платёж занимает больше времени. Проверьте Панель чуть позже.",
  lang_label: "Язык", notif_on: "Уведомления включены 🔔", notif_off: "Уведомления выключены", tz_saved: "Часовой пояс сохранён",
  hiw_open: "Как это работает?",
  hiw_title: "А что, если твой день закончится раньше?",
  hiw_intro: "GaimTime ускоряет твои часы. Ты идёшь быстрее реального времени, поэтому мозг стремится к более раннему окончанию дня — и ты заканчиваешь раньше.",
  hiw_s1_t: "Выбери свой выигрыш", hiw_s1_d: "Ты решаешь, сколько минут выигрывать в час: 5, 10, 15 или 20 мин.",
  hiw_s2_t: "Часы GaimTime ускоряются", hiw_s2_d: "Пока реальное время идёт как обычно, часы GaimTime уходят вперёд, секунда за секундой.",
  hiw_s3_t: "Ты заканчиваешь раньше", hiw_s3_d: "Когда часы GaimTime показывают 17:00, на самом деле только 16:10. Ты выиграл 50 минут.",
  hiw_s4_t: "Планируй задачи с оповещениями", hiw_s4_d: "Планируй задачи по времени GaimTime и получай звуковое оповещение на каждом этапе.",
  hiw_example: "Пример: при +10 мин/час за 8-часовой день твой день GaimTime «заканчивается», когда остаётся ещё 1 ч 20 мин реального времени. Это опережение держит тебя в фокусе.",
  hiw_read: "Читать", hiw_listen: "Слушать", hiw_loading: "Генерация голоса…", hiw_playing: "Воспроизведение…",
  offer_clear_t: "Понятное предложение. Никаких сюрпризов.", offer_clear_sub: "Пожизненный доступ даёт всё главное. Коуч — приятное дополнение, когда захочешь.",
  card1_tag: "Пожизненный доступ · разовый платёж", card2_tag: "Премиум-опция", card2_optional: "(по желанию)",
  card2_title: "GaimTime Coach", card2_price: "9,99 €", card2_feat: "Безлимитный личный коуч", card2_feat2: "Мотивация, решения, перефокусировка", card2_note: "Можно включить в личном кабинете после входа",
  pricing_reassure: "GaimTime работает на 100% без коуча. Коуч — это опция, а не обязанность.",
  listen_msg: "Слушать",
  faq_title: "Частые вопросы",
  faq_q1: "Время правда ускоряется?", faq_a1: "Нет 🙂 Это психологический принцип: показываемые часы GaimTime идут быстрее, что побуждает мозг закончить раньше. Реальное время не меняется.",
  faq_q2: "Я плачу только один раз?", faq_a2: "Да, 4,99€ навсегда, единый платёж. ИИ-коуч — отдельная опция (9,99€/мес), никогда не обязательная.",
  faq_q3: "Что такое GaimTime Coach?", faq_a3: "Личный ИИ-коуч, который мотивирует и помогает с решениями. Опционально, включается в личном кабинете.",
  faq_q4: "Работает на телефоне / офлайн?", faq_a4: "Да, GaimTime — устанавливаемое приложение (PWA) на твоём телефоне, с офлайн-доступом.",
  faq_q5: "Мои данные конфиденциальны?", faq_a5: "Да, твои данные остаются приватными и защищёнными; оплата через Stripe.",
  faq_q6: "Можно отменить подписку на коуча?", faq_a6: "Да, в любой момент. Пожизненный доступ к GaimTime остаётся у тебя.",
  demo_title: "Посмотри, сколько времени ты выигрываешь", demo_sub: "Чем больше минут в час ты выигрываешь, тем раньше заканчивается день.", demo_classic: "Обычный день", demo_withgaim: "С GaimTime", demo_saved: "{v} выиграно 🎉",
  forgot_pw: "Забыли пароль?", forgot_title: "Сброс пароля", forgot_desc: "Введите email, и мы отправим ссылку для выбора нового пароля.", forgot_submit: "Отправить ссылку", forgot_sent: "Если аккаунт с этим email существует, ссылка для сброса только что отправлена.", back_to_login: "← Назад ко входу",
  reset_title: "Новый пароль", reset_desc: "Выберите новый пароль для вашего аккаунта.", reset_new_pw: "Новый пароль", reset_confirm_pw: "Подтвердите пароль", reset_submit: "Обновить пароль", reset_success: "Пароль обновлён! Теперь вы можете войти.", reset_mismatch: "Пароли не совпадают.", reset_invalid_link: "Недействительная или просроченная ссылка. Запросите новую.", reset_short: "Пароль должен содержать не менее 6 символов.",
  edit_profile: "Редактировать профиль", profile_title: "Мой профиль", profile_saved: "Профиль обновлён", save: "Сохранить", cancel: "Отмена",
  coach_cfg_btn: "Настроить коуча", coach_cfg_title: "Настройте вашего коуча и компаньона", coach_cfg_desc: "Всё по желанию — создайте коуча под себя. Меняйте когда угодно: для работы, жизни или другого.",
  cfg_gender: "Пол коуча", cfg_gender_m: "Мужчина", cfg_gender_f: "Женщина",
  cfg_type: "Специализация коуча", type_work: "Работа", type_life: "Жизнь", type_love: "Любовь и отношения", type_intimate: "Близость", type_company: "Компания", type_other: "Другое",
  cfg_tone: "Тон", tone_direct: "Прямой и честный", tone_soft: "Мягкий и заботливый", tone_motiv: "Мотивирующий",
  cfg_nickname: "Как коучу к вам обращаться?", cfg_challenges: "Ваши текущие трудности", cfg_values: "Что для вас важнее всего", cfg_motivation: "Что вас мотивирует",
  support_btn: "Поддержка", tickets_title: "Поддержка и чат", tickets_desc: "Вопрос? Напишите нам — ответим здесь.", ticket_new: "Новое сообщение", ticket_subject: "Тема", ticket_message: "Ваше сообщение", ticket_send: "Отправить", ticket_reply_ph: "Напишите ответ…", ticket_empty: "Пока нет обсуждений.", ticket_open: "Открыт", ticket_closed: "Закрыт", ticket_sent: "Сообщение отправлено!", ticket_back: "← Назад", ticket_you: "Вы", ticket_team: "Команда GaimTime", coach_daily_left: "сообщений осталось сегодня",
  coach_limit_title: "Вы использовали 150 сообщений сегодня 👏", coach_limit_desc: "Возвращайтесь завтра… или продолжите сейчас с пакетом.", coach_buy_pack: "Продолжить · +150 сообщений · 2€", coach_bonus_label: "бонус",
  err_generic: "Что-то пошло не так. Попробуйте ещё раз.",
};

const ar = {
  dev_rename: "إعادة تسمية",
  dev_rename_ph: "اسم الجهاز",
  push_blocks: "منبهات كتل التخطيط",
  pv_pomodoro: "بومودورو",
  pv_pomodoro_done: "تمت إضافة بومودورو: 25 دقيقة تركيز / 5 دقائق استراحة",
  pv_sound: "صوت المنبّه",
  pv_test: "تجربة",
  snd_chime: "رنين",
  snd_bell: "جرس",
  snd_beep: "صفير",
  snd_soft: "ناعم",
  banner_text: "أضف GaimTime إلى شاشتك الرئيسية",
  banner_btn: "تثبيت",
  ia_and_title: "على Android (Chrome)",
  ia_and_1: "افتح قائمة ⋮ في Chrome (أعلى اليمين).",
  ia_and_2: "اضغط على 'تثبيت وإنشاء اختصار'.",
  ia_and_3: "اضغط على 'تثبيت' — تم!",
  install_app: "تثبيت التطبيق",
  ia_title: "ثبّت GaimTime على هاتفك",
  ia_desc: "أضف GaimTime إلى شاشتك الرئيسية: وصول سريع، ملء الشاشة، كتطبيق حقيقي.",
  ia_install_btn: "ثبّت الآن",
  ia_installed: "تم تثبيت GaimTime بالفعل على هذا الجهاز 🎉",
  ia_ios_title: "على iPhone / iPad (Safari)",
  ia_ios_1: "اضغط زر المشاركة أسفل Safari.",
  ia_ios_2: "اختر 'إضافة إلى الشاشة الرئيسية'.",
  ia_ios_3: "اضغط 'إضافة' — تم!",
  ia_soon: "لقطة الشاشة قريبًا",
  pv_add: "إضافة كتلة",
  pv_label: "الاسم",
  pv_type: "النوع",
  pv_task: "مهمة",
  pv_break: "استراحة",
  pv_start: "البداية",
  pv_end: "النهاية",
  pv_alarm_start: "منبّه عند البداية",
  pv_alarm_end: "منبّه عند النهاية",
  pv_free: "متاح",
  pv_save: "إضافة",
  pv_cancel: "إلغاء",
  pv_delete: "حذف",
  pv_invalid: "يجب أن تكون النهاية بعد البداية، ضمن يومك.",
  pv_none: "لا توجد كتل بعد. يومك متاح — أضف أول كتلة!",
  pv_fired: "حان الوقت",
  pv_stop: "إيقاف",
  lifetime_badge: "مدى الحياة",
  daystart_title: "يبدأ يومك في GaimTime! ⏳",
  daystart_body: "لنبدأ — انطلق يومك المضغوط.",
  chpwd_menu: "تغيير كلمة المرور",
  chpwd_title: "تغيير كلمة المرور",
  chpwd_current: "كلمة المرور الحالية",
  chpwd_new: "كلمة المرور الجديدة",
  chpwd_confirm: "تأكيد كلمة المرور الجديدة",
  chpwd_save: "حفظ",
  chpwd_success: "تم تغيير كلمة المرور بنجاح",
  chpwd_err_current: "كلمة المرور الحالية غير صحيحة",
  chpwd_err_short: "كلمة المرور قصيرة جدًا (6 أحرف على الأقل)",
  chpwd_err_match: "كلمتا المرور غير متطابقتين",
  chpwd_err_same: "يجب أن تكون كلمة المرور الجديدة مختلفة",
  pv_reset: "مسح الكل",
  menu_account: "حسابي",
  menu_notif: "الإشعارات",
  menu_help: "الدليل / المساعدة",
  state_on: "مفعّل",
  state_off: "متوقف",
  ob_next: "التالي",
  ob_back: "رجوع",
  ob_skip: "تخطي",
  ob_done: "فهمت!",
  ob_t1: "مرحبًا بك في GaimTime 👋",
  ob_d1: "جولة سريعة للاستفادة القصوى من وقتك. تستغرق 20 ثانية.",
  ob_t2: "ساعتاك",
  ob_d2: "على اليسار الوقت الحقيقي، وعلى اليمين وقت GaimTime المُسرَّع. الفرق هو الوقت الذي تكسبه.",
  ob_t3: "اضبط يومك",
  ob_d3: "اختر هدف الكسب ووقت البدء. 'فتح التخطيط (24س)' ينظّم كتلك الزمنية.",
  ob_t4: "قائمة حسابك",
  ob_d4: "أعلى اليمين: الإشعارات، إعداد مدرب الذكاء الاصطناعي، الساعة في الإشعارات، أجهزتي، الفواتير والمساعدة.",
  ob_t5: "مدرّبك بالذكاء الاصطناعي",
  ob_d5: "تحدّث مع مدربك ورفيقك متى شئت — يحفّزك كصديق مقرّب.",
  lc_title: "الساعة في الإشعارات",
  lc_on: "تم تفعيل ساعة GaimTime في إشعاراتك",
  lc_off: "تم إيقاف ساعة الإشعارات",
  lc_denied: "اسمح بالإشعارات لعرض الساعة",
  lc_unsupported: "جهازك لا يدعم هذه الميزة",
  lc_gaim: "GaimTime",
  lc_gain: "المكسب",
  devices_title: "أجهزتي",
  devices_desc: "يمكنك استخدام جهازين كحد أقصى. افصل جهازًا لتحرير مكان.",
  dev_this_device: "هذا الجهاز",
  devices_empty: "لا توجد أجهزة نشطة.",
  dev_limit_title: "عدد كبير من الأجهزة",
  dev_limit_desc: "لقد وصلت إلى حد الجهازين. افصل جهازًا للمتابعة على هذا الجهاز.",
  dev_disconnect: "فصل",
  dev_seen: "نشط",
  hiw_audio_error: "الصوت غير متاح حاليًا. حاول مرة أخرى بعد لحظات.",
  upgrade_super_btn: "الترقية إلى الذكاء الفائق", plan_standard: "المدرب القياسي", plan_standard_desc: "مساعد ذكاء اصطناعي سريع وطبيعي", plan_super: "الذكاء الفائق", plan_super_desc: "أذكى ذكاء اصطناعي، رسائل وصوت أكثر يوميًا", plan_super_tag: "الأفضل", activate_super: "تفعيل الذكاء الفائق", ps_success_super: "تم تفعيل الذكاء الفائق!", tts_limit_reached: "تم الوصول إلى الحد اليومي للقراءة الصوتية.",
  my_invoices: "فواتيري",
  download: "تنزيل",
  no_invoices: "لا توجد فاتورة بعد.",
  ctx_desc_general: "حديث حر: تكلّم عمّا تريد، مدرّبك هنا من أجلك.",
  ctx_desc_work: "وضع العمل: تركيز وكفاءة — مدرّبك يساعدك على التقدّم.",
  ctx_desc_company: "مجرّد رفقة: نتحدّث، نضحك، وتشعر بأنك مسموع.",
  ctx_desc_advice: "تحتاج نصيحة أو مساعدة في اتخاذ قرار؟ اشرح وضعك.",
  ctx_desc_relax: "وقت الاسترخاء: خفّف عنك وغيّر جوّك.",
  ctx_desc_seduction: "إغراء ومغازلة وحميمية: أجواء مرحة وحسّية (من دون صراحة).",
  clear_thread: "مسح المحادثة",
  clear_thread_q: "مسح هذه المحادثة بالكامل؟",
  clear_thread_desc: "يمسح فقط رسائل هذا الموضوع. تبقى ملاحظة السياق محفوظة.",
  thread_cleared: "تم مسح المحادثة",
  clear_confirm: "مسح",
  note_btn: "ملاحظة السياق",
  note_title: "سياق الموضوع (يتذكّره الذكاء الاصطناعي)",
  note_ph: "صف الموضوع ووضعك وما يجب أن يتذكّره الذكاء الاصطناعي دائمًا…",
  note_hint: "يُحفظ حتى لو مسحت المحادثة. لا يُحتسب ضمن رسائلك.",
  note_saved: "تم حفظ السياق",
  mic_hint: "تحدّث",
  mic_listening: "أستمع… اضغط للإيقاف",
  mic_unsupported: "الإدخال الصوتي غير مدعوم في هذا المتصفح",
  notif_settings: "إعدادات الإشعارات",
  notif_settings_desc: "اختر إشعارات الدفع التي تتلقاها.",
  push_morning: "دفعة الصباح",
  push_midday: "متابعة الظهيرة",
  push_coach: "فكرة المدرّب (ذكاء اصطناعي)",
  push_evening: "ملخص المساء",
  push_night: "تحضير الغد",
  push_reengage: "نفتقدك",
  push_coach_note: "يتطلب اشتراك المدرّب.",
  notif_prefs_saved: "تم حفظ التفضيلات",
  intent_label: "ماذا تحتاج اليوم؟",
  intent_none: "عام",
  intent_work: "عمل جاد",
  intent_company: "رفقة",
  intent_advice: "نصيحة",
  intent_relax: "استرخاء",
  intent_seduction: "إغراء",
  intent_saved: "تمام — سأتكيّف مع يومك 👍",
  nav_login: "تسجيل الدخول", nav_cta: "تفعيل مدى الحياة", nav_logout: "تسجيل الخروج", nav_dashboard: "لوحة التحكم", nav_admin: "الإدارة",
  hero_badge: "مؤتمت 100% · علم النفس الإيجابي",
  hero_t1: "GaimTime: اصنع وقتك الشخصي،", hero_hl: "وعِش وفق قواعدك.", preview_explain: "ساعة GaimTime تتقدّم أسرع → تُنهي يومك أبكر وتربح وقتًا شخصيًا.",
  hero_sub: "لا تدع الوقت يمر دون فائدة. سواء كنت تعمل أو تدرس أو تنظّم أيامك، اربح حتى 20 دقيقة في الساعة وحرّر وقتاً لما يهم حقاً.",
  hero_cta: "تفعيل مدى الحياة", hero_cta_sub: "· 4.99 €",
  hero_trust: "دفعة واحدة · بدون اشتراك خفي · آمن عبر Stripe",
  today_gain: "اليوم · ربح 10 د/س",
  f1_t: "ساعتان متزامنتان", f1_d: "وقتك الحقيقي ووقت GaimTime المتسارع، يتحدثان ثانية بثانية.",
  f2_t: "الربح التراكمي مباشرة", f2_d: "شاهد الوقت الذي تستعيده: حتى ساعة و20 دقيقة في يوم من 8 ساعات.",
  f3_t: "تخطيط مضغوط 24 ساعة", f3_d: "اسقط مهامك في يوم مضغوط وحقق أهدافك أبكر.",
  comp_badge: "مدرب ورفيق GaimTime", comp_t: "مدرب ورفيق ذكاء اصطناعي يعرفك حقاً.",
  comp_d: "ليس مجرد روبوت محادثة. صديق حميم وصادق يستمع وينصح ويدفعك للتحرك. الحب، الشكوك، المشاريع، المخاوف — إنه هنا بلا مرشح.",
  comp_avail: "متاح عبر اشتراك المدرب والرفيق (9.99 €/شهر) من لوحتك.",
  chat_demo_q: "لدي قرار كبير غداً…", chat_demo_a: "حسناً، تنفّس. أخبرني بكل شيء، سنحلها معاً. ما الذي يعيقك حقاً؟",
  pricing_t: "دفعة واحدة. وصول مدى الحياة.", pricing_sub: "لا اشتراك خفي للتطبيق. رفيق الذكاء الاصطناعي اختياري.",
  price_life: "/ مدى الحياة", pf1: "لوحة كاملة وساعات GaimTime", pf2: "تخطيط مضغوط 24 ساعة", pf3: "وفّر حتى 20 دقيقة/ساعة", pf4: "تحديثات مدى الحياة",
  pricing_cta: "تفعيل مدى الحياة",
  footer_contact: "اتصل", footer_cgv: "الشروط", footer_legal: "إشعار قانوني",
  contact_title: "تواصل معنا", contact_desc: "سؤال؟ راسلنا على هذا العنوان:", contact_copy_or: "أو افتح تطبيق بريدك →", copied: "تم نسخ البريد!",
  gain: "الربح", objective_t: "هدف الربح", objective_d: "اختر الدقائق التي تريد ربحها كل ساعة", minh: "د/س", start: "البداية",
  real_clock: "الوقت الحقيقي", gaim_clock: "ساعة GaimTime", conv: "ساعة GaimTime = {n} دقيقة حقيقية",
  gain_cumule: "الربح التراكمي", day8: "اليوم (8 س)", reset_counters: "تصفير العدادات",
  traj_t: "مسار الربح (دقائق / ساعة عمل)", open_planning: "فتح التخطيط (24س)", hide_planning: "إخفاء التخطيط",
  coach_btn: "تحدث مع مدربي ورفيقي", timezone: "المنطقة الزمنية",
  planning_t: "تخطيط مضغوط", add_task: "أضف مهمة…", reset: "تصفير", now: "الآن", real: "حقيقي",
  coach_title: "مدرب ورفيق GaimTime", coach_empty: "مرحباً! أنا هنا من أجلك. أخبرني بما يشغل بالك اليوم. 👋", coach_ph: "اكتب لمدربك…",
  create_acc: "إنشاء حساب", sign_in: "تسجيل الدخول", firstname: "الاسم", lastname: "اللقب", email: "البريد", password: "كلمة المرور", company: "الشركة (اختياري)",
  comp_intro: "تعرّف على مدربك ورفيقك", comp_intro_sub: "اختياري — لمدرب ذكاء اصطناعي يعرفك حقاً.",
  situation_ph: "وضعك الحياتي (العمل، العائلة…)", goals_ph: "أهدافك الحالية", interests_ph: "اهتماماتك",
  login_submit: "تسجيل الدخول", secure_pay: "دفع آمن عبر Stripe",
  coachdlg_desc: "افتح مدرب ورفيق حياتك بالذكاء الاصطناعي: صديق حميم وصادق، متاح 24/7.", permonth: "/ شهر", activate_coach: "تفعيل المدرب والرفيق — 9.99 €/شهر",
  ps_checking: "جارٍ التحقق من دفعتك…", ps_wait_t: "لحظة…", ps_success_life: "تم تفعيل الوصول مدى الحياة!", ps_success_coach: "تم تفعيل المدرب والرفيق!",
  ps_done: "تم!", ps_oops: "عذراً", ps_go_dash: "إلى اللوحة", ps_notfound: "جلسة الدفع غير موجودة.", ps_slow: "الدفع يستغرق وقتاً أطول من المتوقع. تحقق من لوحتك قريباً.",
  lang_label: "اللغة", notif_on: "تم تفعيل الإشعارات 🔔", notif_off: "تم إيقاف الإشعارات", tz_saved: "تم حفظ المنطقة الزمنية",
  hiw_open: "كيف يعمل؟",
  hiw_title: "ماذا لو انتهى يومك مبكرًا؟",
  hiw_intro: "يُسرّع GaimTime ساعتك. أنت تتقدّم أسرع من الزمن الحقيقي، فيستهدف عقلك نهاية يوم أقرب — وتنتهي مبكرًا.",
  hiw_s1_t: "اختر مكسبك", hiw_s1_d: "أنت تقرّر كم دقيقة تكسب في الساعة: 5 أو 10 أو 15 أو 20 دقيقة.",
  hiw_s2_t: "تتسارع ساعة GaimTime", hiw_s2_d: "بينما يسير الزمن الحقيقي بشكل طبيعي، تتقدّم ساعة GaimTime ثانية بثانية.",
  hiw_s3_t: "تنتهي مبكرًا", hiw_s3_d: "عندما تُظهر ساعة GaimTime الخامسة مساءً، تكون في الحقيقة 4:10 فقط. لقد كسبت 50 دقيقة.",
  hiw_s4_t: "خطّط مهامك مع تنبيهات", hiw_s4_d: "جدوِل مهامك بتوقيت GaimTime واحصل على تنبيه صوتي لكل مرحلة.",
  hiw_example: "مثال: مع +10 دقائق/ساعة، خلال يوم من 8 ساعات «ينتهي» يومك في GaimTime بينما لا يزال أمامك ساعة و20 دقيقة من الزمن الحقيقي. هذا التقدّم يبقيك مركّزًا.",
  hiw_read: "قراءة", hiw_listen: "استماع", hiw_loading: "جارٍ توليد الصوت…", hiw_playing: "جارٍ التشغيل…",
  offer_clear_t: "عرض واضح. بلا مفاجآت.", offer_clear_sub: "وصولك مدى الحياة يمنحك كل الأساسيات. المدرّب إضافة لطيفة متى شئت.",
  card1_tag: "وصول مدى الحياة · دفعة واحدة", card2_tag: "خيار مميّز", card2_optional: "(اختياري)",
  card2_title: "GaimTime Coach", card2_price: "9.99 €", card2_feat: "مدرّب شخصي غير محدود", card2_feat2: "تحفيز وقرارات وإعادة تركيز", card2_note: "يمكن تفعيله من مساحتك بعد تسجيل الدخول",
  pricing_reassure: "يعمل GaimTime بنسبة 100% بدون المدرّب. المدرّب خيار وليس إلزاميًا.",
  listen_msg: "استماع",
  faq_title: "الأسئلة الشائعة",
  faq_q1: "هل يتسارع الوقت فعلًا؟", faq_a1: "لا 🙂 إنه مبدأ نفسي: ساعة GaimTime المعروضة تسير أسرع، مما يدفع عقلك لإنهاء العمل مبكرًا. الوقت الحقيقي لا يتغير.",
  faq_q2: "هل أدفع مرة واحدة فقط؟", faq_a2: "نعم، 4.99€ مدى الحياة، دفعة واحدة. مدرّب الذكاء الاصطناعي خيار منفصل (9.99€/شهر)، وليس إلزاميًا أبدًا.",
  faq_q3: "ما هو GaimTime Coach؟", faq_a3: "مدرّب شخصي بالذكاء الاصطناعي يحفّزك ويساعدك في قراراتك. اختياري، يمكن تفعيله من مساحتك.",
  faq_q4: "هل يعمل على الجوال / دون اتصال؟", faq_a4: "نعم، GaimTime تطبيق قابل للتثبيت (PWA) على هاتفك، مع وصول دون اتصال.",
  faq_q5: "هل بياناتي خاصة؟", faq_a5: "نعم، تبقى بياناتك خاصة وآمنة؛ ويتم الدفع عبر Stripe.",
  faq_q6: "هل يمكنني إلغاء اشتراك المدرّب؟", faq_a6: "نعم، في أي وقت. ويبقى وصولك مدى الحياة إلى GaimTime لك.",
  demo_title: "شاهد الوقت الذي تكسبه", demo_sub: "كلما ربحت دقائق أكثر في الساعة، انتهى يومك مبكرًا أكثر.", demo_classic: "يوم عادي", demo_withgaim: "مع GaimTime", demo_saved: "تم كسب {v} 🎉",
  forgot_pw: "هل نسيت كلمة المرور؟", forgot_title: "إعادة تعيين كلمة المرور", forgot_desc: "أدخل بريدك الإلكتروني وسنرسل لك رابطًا لاختيار كلمة مرور جديدة.", forgot_submit: "إرسال الرابط", forgot_sent: "إذا كان هناك حساب لهذا البريد، فقد تم إرسال رابط إعادة التعيين للتو.", back_to_login: "← العودة إلى تسجيل الدخول",
  reset_title: "كلمة مرور جديدة", reset_desc: "اختر كلمة مرور جديدة لحسابك.", reset_new_pw: "كلمة مرور جديدة", reset_confirm_pw: "تأكيد كلمة المرور", reset_submit: "تحديث كلمة المرور", reset_success: "تم تحديث كلمة المرور! يمكنك تسجيل الدخول الآن.", reset_mismatch: "كلمتا المرور غير متطابقتين.", reset_invalid_link: "رابط غير صالح أو منتهي الصلاحية. اطلب رابطًا جديدًا.", reset_short: "يجب أن تتكون كلمة المرور من 6 أحرف على الأقل.",
  edit_profile: "تعديل ملفي الشخصي", profile_title: "ملفي الشخصي", profile_saved: "تم تحديث الملف الشخصي", save: "حفظ", cancel: "إلغاء",
  coach_cfg_btn: "إعداد مدرّبي", coach_cfg_title: "أعدّ مدرّبك ورفيقك", coach_cfg_desc: "كل شيء اختياري — صمّم مدرّبًا يناسبك. غيّره متى شئت، للعمل أو الحياة أو غير ذلك.",
  cfg_gender: "جنس المدرّب", cfg_gender_m: "رجل", cfg_gender_f: "امرأة",
  cfg_type: "تخصص المدرّب", type_work: "العمل", type_life: "الحياة", type_love: "الحب والعلاقات", type_intimate: "الحميمية", type_company: "الرفقة", type_other: "أخرى",
  cfg_tone: "الأسلوب", tone_direct: "مباشر وصريح", tone_soft: "لطيف وحنون", tone_motiv: "محفّز",
  cfg_nickname: "بماذا يناديك المدرّب؟", cfg_challenges: "تحدياتك أو عوائقك الحالية", cfg_values: "ما يهمّك أكثر", cfg_motivation: "ما الذي يحفّزك",
  support_btn: "الدعم", tickets_title: "الدعم والمحادثة", tickets_desc: "لديك سؤال؟ راسلنا، نرد عليك هنا.", ticket_new: "رسالة جديدة", ticket_subject: "الموضوع", ticket_message: "رسالتك", ticket_send: "إرسال", ticket_reply_ph: "اكتب ردك…", ticket_empty: "لا توجد محادثات بعد.", ticket_open: "مفتوح", ticket_closed: "مغلق", ticket_sent: "تم إرسال الرسالة!", ticket_back: "← رجوع", ticket_you: "أنت", ticket_team: "فريق GaimTime", coach_daily_left: "رسائل متبقية اليوم",
  coach_limit_title: "لقد وصلت إلى 150 رسالة اليوم 👏", coach_limit_desc: "عد غدًا… أو تابع الآن بحزمة.", coach_buy_pack: "متابعة · +150 رسالة · 2€", coach_bonus_label: "إضافي",
  err_generic: "حدث خطأ ما. حاول مرة أخرى.",
};

const zh = {
  dev_rename: "重命名",
  dev_rename_ph: "设备名称",
  push_blocks: "计划时段闹钟",
  pv_pomodoro: "番茄钟",
  pv_pomodoro_done: "已添加番茄钟：专注 25 分钟 / 休息 5 分钟",
  pv_sound: "闹钟声音",
  pv_test: "试听",
  snd_chime: "风铃",
  snd_bell: "铃声",
  snd_beep: "蜂鸣",
  snd_soft: "柔和",
  banner_text: "把 GaimTime 添加到主屏幕",
  banner_btn: "安装",
  ia_and_title: "在 Android（Chrome）",
  ia_and_1: "打开 Chrome 的菜单 ⋮（右上角）。",
  ia_and_2: "点按「安装并创建快捷方式」。",
  ia_and_3: "点按「安装」——完成！",
  install_app: "安装应用",
  ia_title: "在手机上安装 GaimTime",
  ia_desc: "把 GaimTime 添加到主屏幕：快速访问、全屏，如同真正的应用。",
  ia_install_btn: "立即安装",
  ia_installed: "GaimTime 已安装在此设备上 🎉",
  ia_ios_title: "在 iPhone / iPad（Safari）",
  ia_ios_1: "点按 Safari 底部的分享按钮。",
  ia_ios_2: "选择「添加到主屏幕」。",
  ia_ios_3: "点按「添加」——完成！",
  ia_soon: "截图即将上线",
  pv_add: "添加时段",
  pv_label: "名称",
  pv_type: "类型",
  pv_task: "任务",
  pv_break: "休息",
  pv_start: "开始",
  pv_end: "结束",
  pv_alarm_start: "开始时闹钟",
  pv_alarm_end: "结束时闹钟",
  pv_free: "空闲",
  pv_save: "添加",
  pv_cancel: "取消",
  pv_delete: "删除",
  pv_invalid: "结束必须晚于开始，且在你的一天之内。",
  pv_none: "还没有时段。你的一天是空闲的——添加第一个吧！",
  pv_fired: "时间到",
  pv_stop: "停止",
  lifetime_badge: "终身",
  daystart_title: "你的 GaimTime 一天开始了！⏳",
  daystart_body: "开始吧——你的压缩日程已启动。",
  chpwd_menu: "修改密码",
  chpwd_title: "修改密码",
  chpwd_current: "当前密码",
  chpwd_new: "新密码",
  chpwd_confirm: "确认新密码",
  chpwd_save: "保存",
  chpwd_success: "密码修改成功",
  chpwd_err_current: "当前密码不正确",
  chpwd_err_short: "密码太短（至少6个字符）",
  chpwd_err_match: "两次密码不一致",
  chpwd_err_same: "新密码必须不同",
  pv_reset: "全部清除",
  menu_account: "我的账户",
  menu_notif: "通知",
  menu_help: "指南 / 帮助",
  state_on: "开",
  state_off: "关",
  ob_next: "下一步",
  ob_back: "上一步",
  ob_skip: "跳过",
  ob_done: "明白了！",
  ob_t1: "欢迎来到 GaimTime 👋",
  ob_d1: "快速导览，充分利用你的时间，只需 20 秒。",
  ob_t2: "你的两个时钟",
  ob_d2: "左边是真实时间，右边是加速的 GaimTime。两者之差就是你赢得的时间。",
  ob_t3: "设置你的一天",
  ob_d3: "选择你的收益目标和开始时间。「打开日程（24小时）」帮你安排时间块。",
  ob_t4: "你的账户菜单",
  ob_d4: "右上角：通知、AI 教练设置、通知中的时钟、我的设备、账单与帮助，尽在一处。",
  ob_t5: "你的 AI 教练",
  ob_d5: "随时与你的教练兼伙伴聊天——像挚友一样激励你。",
  lc_title: "通知中的时钟",
  lc_on: "已在通知中开启 GaimTime 时钟",
  lc_off: "已关闭通知时钟",
  lc_denied: "请允许通知以显示时钟",
  lc_unsupported: "你的设备不支持此功能",
  lc_gaim: "GaimTime",
  lc_gain: "收益",
  devices_title: "我的设备",
  devices_desc: "最多可使用 2 台设备。断开一台以释放名额。",
  dev_this_device: "此设备",
  devices_empty: "没有活跃设备。",
  dev_limit_title: "设备过多",
  dev_limit_desc: "你已达到 2 台设备的上限。请断开一台设备以在此设备上继续。",
  dev_disconnect: "断开",
  dev_seen: "活跃",
  hiw_audio_error: "音频暂时不可用，请稍后再试。",
  upgrade_super_btn: "升级到超级 AI", plan_standard: "标准教练", plan_standard_desc: "快速自然的 AI 助手", plan_super: "超级 AI", plan_super_desc: "最聪明的 AI，每天更多消息和语音", plan_super_tag: "最佳", activate_super: "激活超级 AI", ps_success_super: "超级 AI 已激活！", tts_limit_reached: "已达到每日语音播放上限。",
  my_invoices: "我的发票",
  download: "下载",
  no_invoices: "暂无发票。",
  ctx_desc_general: "自由聊天：想聊什么都行，你的教练在这里陪你。",
  ctx_desc_work: "工作模式：专注与高效——教练帮你向前推进。",
  ctx_desc_company: "只是陪伴：我们聊聊、笑笑，你被倾听。",
  ctx_desc_advice: "需要建议或帮你做决定？说说你的情况。",
  ctx_desc_relax: "放松时刻：解压、换换心情。",
  ctx_desc_seduction: "调情、诱惑与亲密：默契而感性的氛围（绝不露骨）。",
  clear_thread: "清空对话",
  clear_thread_q: "清空整个对话？",
  clear_thread_desc: "只会删除该主题的消息。你保存的上下文备注会保留。",
  thread_cleared: "对话已清空",
  clear_confirm: "清空",
  note_btn: "上下文备注",
  note_title: "主题上下文（AI 会记住）",
  note_ph: "描述主题、你的情况，以及 AI 应始终记住的内容…",
  note_hint: "即使清空对话也会保留。不计入你的消息数。",
  note_saved: "上下文已保存",
  mic_hint: "说话",
  mic_listening: "正在聆听……点按停止",
  mic_unsupported: "此浏览器不支持语音输入",
  notif_settings: "通知设置",
  notif_settings_desc: "选择你想接收的推送通知。",
  push_morning: "早晨动力",
  push_midday: "午间打卡",
  push_coach: "教练点子（AI）",
  push_evening: "晚间总结",
  push_night: "准备明天",
  push_reengage: "我们想你了",
  push_coach_note: "需要教练订阅。",
  notif_prefs_saved: "偏好已保存",
  intent_label: "你今天需要什么？",
  intent_none: "通用",
  intent_work: "认真工作",
  intent_company: "陪伴",
  intent_advice: "建议",
  intent_relax: "放松",
  intent_seduction: "情感",
  intent_saved: "收到——我会配合你的一天 👍",
  nav_login: "登录", nav_cta: "永久激活", nav_logout: "退出", nav_dashboard: "仪表板", nav_admin: "管理",
  hero_badge: "100% 自动化 · 积极心理学",
  hero_t1: "GaimTime：创造你的个人时间，", hero_hl: "按你的规则生活。", preview_explain: "你的 GaimTime 时钟走得更快 → 你更早结束一天，赢得个人时间。",
  hero_sub: "别再让时间白白流逝。无论你在工作、学习还是安排日常，每小时最多赢得 20 分钟，为真正重要的事腾出时间。",
  hero_cta: "永久激活", hero_cta_sub: "· 4.99 €",
  hero_trust: "一次性付款 · 无隐藏订阅 · Stripe 安全支付",
  today_gain: "今天 · 收益 10 分钟/小时",
  f1_t: "两个同步时钟", f1_d: "你的真实时间与加速的 GaimTime，逐秒更新。",
  f2_t: "实时累计收益", f2_d: "看看你回收的时间：8 小时工作日最多可省 1 小时 20 分钟。",
  f3_t: "24 小时压缩计划", f3_d: "将任务投射到压缩的一天，更早达成目标。",
  comp_badge: "GaimTime 教练与伙伴", comp_t: "真正了解你的 AI 教练与伙伴。",
  comp_d: "不只是聊天机器人。一位亲密而诚实的朋友，倾听、建议并推动你行动。爱情、疑惑、计划、恐惧——它都在，毫无保留。",
  comp_avail: "通过教练与伙伴订阅（9.99 €/月）在仪表板中使用。",
  chat_demo_q: "我明天要做一个重大决定……", chat_demo_a: "好，深呼吸。把一切告诉我，我们一起理清。到底是什么在阻碍你？",
  pricing_t: "一次付款。终身访问。", pricing_sub: "应用没有隐藏订阅。AI 伙伴保持可选。",
  price_life: "/ 终身", pf1: "完整仪表板与 GaimTime 时钟", pf2: "24 小时压缩计划", pf3: "每小时最多省 20 分钟", pf4: "终身更新",
  pricing_cta: "永久激活",
  footer_contact: "联系", footer_cgv: "条款", footer_legal: "法律声明",
  contact_title: "联系我们", contact_desc: "有问题？发邮件到此地址：", contact_copy_or: "或打开你的邮件应用 →", copied: "邮箱已复制！",
  gain: "收益", objective_t: "收益目标", objective_d: "选择你想每小时赢得的分钟数", minh: "分钟/时", start: "开始",
  real_clock: "真实时间", gaim_clock: "GaimTime 时刻", conv: "1 小时 GaimTime = {n} 真实分钟",
  gain_cumule: "累计收益", day8: "一天（8小时）", reset_counters: "重置计数器",
  traj_t: "收益轨迹（分钟 / 工作小时）", open_planning: "打开计划（24小时）", hide_planning: "隐藏计划",
  coach_btn: "与我的教练与伙伴聊天", timezone: "时区",
  planning_t: "压缩计划", add_task: "添加任务…", reset: "重置", now: "现在", real: "真实",
  coach_title: "GaimTime 教练与伙伴", coach_empty: "嗨！我在这里陪你。告诉我今天你在想什么。👋", coach_ph: "给你的教练写点什么…",
  create_acc: "创建账户", sign_in: "登录", firstname: "名", lastname: "姓", email: "邮箱", password: "密码", company: "公司（可选）",
  comp_intro: "认识你的教练与伙伴", comp_intro_sub: "可选——为一个真正了解你的 AI 教练。",
  situation_ph: "你的生活状况（工作、家庭…）", goals_ph: "你当前的目标", interests_ph: "你的兴趣",
  login_submit: "登录", secure_pay: "通过 Stripe 安全支付",
  coachdlg_desc: "解锁你的 AI 人生教练与伙伴：一位亲密诚实的朋友，24/7 在线。", permonth: "/ 月", activate_coach: "激活教练与伙伴 — 9.99 €/月",
  ps_checking: "正在验证你的付款…", ps_wait_t: "稍等…", ps_success_life: "终身访问已激活！", ps_success_coach: "教练与伙伴已激活！",
  ps_done: "完成！", ps_oops: "哎呀", ps_go_dash: "前往仪表板", ps_notfound: "未找到支付会话。", ps_slow: "支付时间比预期长。请稍后查看仪表板。",
  lang_label: "语言", notif_on: "通知已开启 🔔", notif_off: "通知已关闭", tz_saved: "时区已保存",
  hiw_open: "如何运作？",
  hiw_title: "如果你的一天更早结束会怎样？",
  hiw_intro: "GaimTime 加快你的时钟。你比真实时间走得更快，大脑因此瞄准更早的收工时间——你会提前完成。",
  hiw_s1_t: "选择你的收益", hiw_s1_d: "你决定每小时省下多少分钟：5、10、15 或 20 分钟。",
  hiw_s2_t: "你的 GaimTime 时钟加速", hiw_s2_d: "当真实时间正常流逝时，你的 GaimTime 时钟一秒一秒地领先。",
  hiw_s3_t: "你更早结束", hiw_s3_d: "当你的 GaimTime 时钟显示 17 点时，实际上才 16:10。你赚到了 50 分钟。",
  hiw_s4_t: "用提醒规划你的任务", hiw_s4_d: "按GaimTime时间安排你的任务，每个步骤都会收到铃声提醒。",
  hiw_example: "例如：以每小时 +10 分钟计算，在 8 小时的一天里，当你还剩 1 小时 20 分钟真实时间时，你的 GaimTime 一天就“结束”了。这份领先让你保持专注。",
  hiw_read: "阅读", hiw_listen: "收听", hiw_loading: "正在生成语音…", hiw_playing: "播放中…",
  offer_clear_t: "清晰的方案。毫无意外。", offer_clear_sub: "终身访问已包含所有核心功能。教练是随时可选的加分项。",
  card1_tag: "终身访问 · 一次性付款", card2_tag: "高级选项", card2_optional: "（可选）",
  card2_title: "GaimTime Coach", card2_price: "€9.99", card2_feat: "无限个人教练", card2_feat2: "激励、决策、重新聚焦", card2_note: "登录后可在你的空间中启用",
  pricing_reassure: "GaimTime 无需教练即可 100% 运行。教练是一个选项，绝非强制。",
  listen_msg: "收听",
  faq_title: "常见问题",
  faq_q1: "时间真的会加速吗？", faq_a1: "不会 🙂 这是一个心理学原理：显示的 GaimTime 时钟走得更快，促使你的大脑更早完成。真实时间不会改变。",
  faq_q2: "我只需付款一次吗？", faq_a2: "是的，4.99€ 终身，一次性付款。AI 教练是单独的选项（9.99€/月），绝非强制。",
  faq_q3: "GaimTime Coach 是什么？", faq_a3: "一位激励你并帮助你做决定的 AI 私人教练。可选，可在你的空间中启用。",
  faq_q4: "支持手机 / 离线使用吗？", faq_a4: "支持，GaimTime 是可安装到手机的应用（PWA），并支持离线访问。",
  faq_q5: "我的数据是私密的吗？", faq_a5: "是的，你的数据保持私密和安全；付款通过 Stripe 处理。",
  faq_q6: "我可以取消教练订阅吗？", faq_a6: "可以，随时取消。你的 GaimTime 终身访问权限依然保留。",
  demo_title: "看看你节省了多少时间", demo_sub: "每小时赢得的分钟越多，你的一天结束得越早。", demo_classic: "普通的一天", demo_withgaim: "使用 GaimTime", demo_saved: "节省 {v} 🎉",
  forgot_pw: "忘记密码？", forgot_title: "重置密码", forgot_desc: "输入你的邮箱，我们会发送一个链接让你设置新密码。", forgot_submit: "发送链接", forgot_sent: "如果该邮箱存在账户，重置链接已发送。", back_to_login: "← 返回登录",
  reset_title: "新密码", reset_desc: "为你的账户设置一个新密码。", reset_new_pw: "新密码", reset_confirm_pw: "确认密码", reset_submit: "更新密码", reset_success: "密码已更新！你现在可以登录了。", reset_mismatch: "两次密码不一致。", reset_invalid_link: "链接无效或已过期。请重新申请。", reset_short: "密码至少需要 6 个字符。",
  edit_profile: "编辑我的资料", profile_title: "我的资料", profile_saved: "资料已更新", save: "保存", cancel: "取消",
  coach_cfg_btn: "设置我的教练", coach_cfg_title: "设置你的教练与伙伴", coach_cfg_desc: "全部可选——打造真正适合你的教练。随时可改，用于工作、生活或其他。",
  cfg_gender: "教练性别", cfg_gender_m: "男", cfg_gender_f: "女",
  cfg_type: "教练领域", type_work: "工作", type_life: "生活", type_love: "爱情与关系", type_intimate: "亲密", type_company: "陪伴", type_other: "其他",
  cfg_tone: "语气", tone_direct: "直接坦率", tone_soft: "温柔体贴", tone_motiv: "激励",
  cfg_nickname: "教练该怎么称呼你？", cfg_challenges: "你当前的挑战或困扰", cfg_values: "你最看重的东西", cfg_motivation: "激励你的是什么",
  support_btn: "支持", tickets_title: "支持与对话", tickets_desc: "有问题？给我们留言，我们在这里回复你。", ticket_new: "新消息", ticket_subject: "主题", ticket_message: "你的消息", ticket_send: "发送", ticket_reply_ph: "写下你的回复…", ticket_empty: "还没有对话。", ticket_open: "进行中", ticket_closed: "已关闭", ticket_sent: "消息已发送！", ticket_back: "← 返回", ticket_you: "你", ticket_team: "GaimTime 团队", coach_daily_left: "今日剩余消息",
  coach_limit_title: "你今天已达到 150 条消息 👏", coach_limit_desc: "明天再来……或立即购买一个包继续。", coach_buy_pack: "继续 · +150 条消息 · 2€", coach_bonus_label: "奖励",
  err_generic: "出了点问题，请重试。",
};

const ja = {
  dev_rename: "名前を変更",
  dev_rename_ph: "デバイス名",
  push_blocks: "計画ブロックのアラーム",
  pv_pomodoro: "ポモドーロ",
  pv_pomodoro_done: "ポモドーロを追加：集中25分 / 休憩5分",
  pv_sound: "アラーム音",
  pv_test: "試聴",
  snd_chime: "チャイム",
  snd_bell: "ベル",
  snd_beep: "ビープ",
  snd_soft: "ソフト",
  banner_text: "GaimTime をホーム画面に追加",
  banner_btn: "インストール",
  ia_and_title: "Android（Chrome）",
  ia_and_1: "Chrome のメニュー ⋮（右上）を開く。",
  ia_and_2: "「インストールしてショートカットを作成」をタップ。",
  ia_and_3: "「インストール」をタップ — 完了！",
  install_app: "アプリをインストール",
  ia_title: "GaimTime をスマホにインストール",
  ia_desc: "GaimTime をホーム画面に追加：素早くアクセス、全画面、本物のアプリのように。",
  ia_install_btn: "今すぐインストール",
  ia_installed: "GaimTime はこの端末に既にインストール済みです 🎉",
  ia_ios_title: "iPhone / iPad（Safari）",
  ia_ios_1: "Safari 下部の共有ボタンをタップ。",
  ia_ios_2: "「ホーム画面に追加」を選択。",
  ia_ios_3: "「追加」をタップ — 完了！",
  ia_soon: "スクリーンショットは近日公開",
  pv_add: "ブロックを追加",
  pv_label: "名前",
  pv_type: "種類",
  pv_task: "タスク",
  pv_break: "休憩",
  pv_start: "開始",
  pv_end: "終了",
  pv_alarm_start: "開始時にアラーム",
  pv_alarm_end: "終了時にアラーム",
  pv_free: "空き",
  pv_save: "追加",
  pv_cancel: "キャンセル",
  pv_delete: "削除",
  pv_invalid: "終了は開始より後、1日の範囲内にしてください。",
  pv_none: "まだブロックがありません。1日は空きです — 最初のブロックを追加！",
  pv_fired: "時間です",
  pv_stop: "停止",
  lifetime_badge: "永久",
  daystart_title: "GaimTime の1日が始まります！⏳",
  daystart_body: "さあ始めよう — 圧縮された1日がスタートしました。",
  chpwd_menu: "パスワード変更",
  chpwd_title: "パスワード変更",
  chpwd_current: "現在のパスワード",
  chpwd_new: "新しいパスワード",
  chpwd_confirm: "新しいパスワードを確認",
  chpwd_save: "保存",
  chpwd_success: "パスワードを変更しました",
  chpwd_err_current: "現在のパスワードが正しくありません",
  chpwd_err_short: "パスワードが短すぎます（最低6文字）",
  chpwd_err_match: "パスワードが一致しません",
  chpwd_err_same: "新しいパスワードは異なる必要があります",
  pv_reset: "すべて消去",
  menu_account: "マイアカウント",
  menu_notif: "通知",
  menu_help: "ガイド / ヘルプ",
  state_on: "オン",
  state_off: "オフ",
  ob_next: "次へ",
  ob_back: "戻る",
  ob_skip: "スキップ",
  ob_done: "わかった！",
  ob_t1: "GaimTime へようこそ 👋",
  ob_d1: "時間を最大限に活かすための短いツアーです。20秒で終わります。",
  ob_t2: "2つの時計",
  ob_d2: "左が実時間、右が加速した GaimTime。その差があなたの得た時間です。",
  ob_t3: "1日を設定",
  ob_d3: "獲得目標と開始時刻を選びましょう。「プランを開く（24時間）」で時間ブロックを整理します。",
  ob_t4: "アカウントメニュー",
  ob_d4: "右上：通知、AIコーチ設定、通知の時計、マイデバイス、請求書、ヘルプがまとめてあります。",
  ob_t5: "あなたのAIコーチ",
  ob_d5: "いつでもコーチ兼相棒とチャット。親友のようにあなたを励まします。",
  lc_title: "通知の時計",
  lc_on: "通知に GaimTime 時計を表示しました",
  lc_off: "通知の時計を無効にしました",
  lc_denied: "時計を表示するには通知を許可してください",
  lc_unsupported: "お使いのデバイスは対応していません",
  lc_gaim: "GaimTime",
  lc_gain: "獲得",
  devices_title: "マイデバイス",
  devices_desc: "最大2台まで使用できます。1台を切断して枠を空けられます。",
  dev_this_device: "このデバイス",
  devices_empty: "アクティブなデバイスはありません。",
  dev_limit_title: "デバイスが多すぎます",
  dev_limit_desc: "2台のデバイス上限に達しました。このデバイスで続けるには1台を切断してください。",
  dev_disconnect: "切断",
  dev_seen: "アクティブ",
  hiw_audio_error: "現在オーディオを利用できません。しばらくしてからもう一度お試しください。",
  upgrade_super_btn: "スーパーAIにアップグレード", plan_standard: "スタンダードコーチ", plan_standard_desc: "高速で自然なAIアシスタント", plan_super: "スーパーAI", plan_super_desc: "最も賢いAI、1日あたりのメッセージと音声が増加", plan_super_tag: "ベスト", activate_super: "スーパーAIを有効化", ps_success_super: "スーパーAIが有効になりました！", tts_limit_reached: "本日の音声読み上げの上限に達しました。",
  my_invoices: "私の請求書",
  download: "ダウンロード",
  no_invoices: "まだ請求書はありません。",
  ctx_desc_general: "自由なおしゃべり：何でも話して、コーチがそばにいます。",
  ctx_desc_work: "仕事モード：集中と効率——コーチが前進を後押しします。",
  ctx_desc_company: "ただの話し相手：おしゃべりして笑って、聞いてもらえます。",
  ctx_desc_advice: "アドバイスや決断の助けが必要？状況を教えて。",
  ctx_desc_relax: "リラックスタイム：肩の力を抜いて気分転換。",
  ctx_desc_seduction: "恋愛・フリート・親密さ：遊び心のある官能的な雰囲気（露骨さはなし）。",
  clear_thread: "会話を消去",
  clear_thread_q: "この会話をすべて消去しますか？",
  clear_thread_desc: "このトピックのメッセージのみ削除します。保存したコンテキストメモは残ります。",
  thread_cleared: "会話を消去しました",
  clear_confirm: "消去",
  note_btn: "コンテキストメモ",
  note_title: "トピックの文脈（AIが記憶）",
  note_ph: "トピック、あなたの状況、AIが常に覚えておくべきことを書いてください…",
  note_hint: "会話を消してもメモは残ります。メッセージ数には含まれません。",
  note_saved: "コンテキストを保存しました",
  mic_hint: "話す",
  mic_listening: "聞いています…タップで停止",
  mic_unsupported: "このブラウザは音声入力に対応していません",
  notif_settings: "通知設定",
  notif_settings_desc: "受け取るプッシュ通知を選びましょう。",
  push_morning: "朝のブースト",
  push_midday: "昼のチェックイン",
  push_coach: "コーチのアイデア（AI）",
  push_evening: "夜のまとめ",
  push_night: "明日の準備",
  push_reengage: "会いたいです",
  push_coach_note: "コーチのサブスクが必要です。",
  notif_prefs_saved: "設定を保存しました",
  intent_label: "今日は何が必要？",
  intent_none: "全般",
  intent_work: "真剣に仕事",
  intent_company: "話し相手",
  intent_advice: "アドバイス",
  intent_relax: "リラックス",
  intent_seduction: "恋愛",
  intent_saved: "了解 — 今日のあなたに合わせます 👍",
  nav_login: "ログイン", nav_cta: "永久に有効化", nav_logout: "ログアウト", nav_dashboard: "ダッシュボード", nav_admin: "管理",
  hero_badge: "100%自動化 · ポジティブ心理学",
  hero_t1: "GaimTime：あなたの自分時間をつくり、", hero_hl: "自分のルールで生きよう。", preview_explain: "あなたのGaimTime時計は速く進む → 一日を早く終え、自分時間を手に入れる。",
  hero_sub: "時間が過ぎ去るのをただ見ているのは終わり。働く人も、学ぶ人も、1日を整えたい人も、1時間あたり最大20分を稼ぎ、本当に大切なことに時間を。",
  hero_cta: "永久に有効化", hero_cta_sub: "· 4.99 €",
  hero_trust: "一括払い · 隠れたサブスクなし · Stripeで安全",
  today_gain: "今日 · 獲得 10分/時",
  f1_t: "同期する2つの時計", f1_d: "実際の時刻と加速したGaimTimeを1秒ごとに更新。",
  f2_t: "累積ゲインをライブ表示", f2_d: "取り戻した時間を確認：8時間労働で最大1時間20分。",
  f3_t: "24時間圧縮プランニング", f3_d: "タスクを圧縮した1日に投影し、目標をより早く達成。",
  comp_badge: "GaimTime コーチ＆コンパニオン", comp_t: "あなたを本当に理解するAIコーチ＆相棒。",
  comp_d: "単なるチャットボットではありません。話を聞き、助言し、行動を後押しする親密で正直な友人。愛、迷い、計画、不安——フィルターなしでそばにいます。",
  comp_avail: "コーチ＆コンパニオン購読（9.99 €/月）でダッシュボードから利用可能。",
  chat_demo_q: "明日、大きな決断をしないといけない…", chat_demo_a: "よし、深呼吸して。全部話して、一緒に整理しよう。本当に何が引っかかってる？",
  pricing_t: "一度の支払い。生涯アクセス。", pricing_sub: "アプリに隠れたサブスクはありません。AIコンパニオンは任意。",
  price_life: "/ 生涯", pf1: "フルダッシュボードとGaimTime時計", pf2: "24時間圧縮プランニング", pf3: "1時間で最大20分節約", pf4: "生涯アップデート",
  pricing_cta: "永久に有効化",
  footer_contact: "お問い合わせ", footer_cgv: "規約", footer_legal: "法的通知",
  contact_title: "お問い合わせ", contact_desc: "ご質問は？このアドレスまで：", contact_copy_or: "またはメールアプリを開く →", copied: "メールをコピーしました！",
  gain: "ゲイン", objective_t: "ゲイン目標", objective_d: "毎時間で得たい分数を選んでください", minh: "分/時", start: "開始",
  real_clock: "実際の時刻", gaim_clock: "GaimTime の時刻", conv: "GaimTime 1時間 = 実 {n} 分",
  gain_cumule: "累積ゲイン", day8: "1日（8時間）", reset_counters: "カウンターをリセット",
  traj_t: "ゲイン推移（分 / 労働時間）", open_planning: "プランニングを開く（24時間）", hide_planning: "プランニングを隠す",
  coach_btn: "コーチ＆コンパニオンと話す", timezone: "タイムゾーン",
  planning_t: "圧縮プランニング", add_task: "タスクを追加…", reset: "リセット", now: "今", real: "実",
  coach_title: "GaimTime コーチ＆コンパニオン", coach_empty: "やあ！あなたのためにここにいるよ。今日は何が気になってる？👋", coach_ph: "コーチにメッセージ…",
  create_acc: "アカウント作成", sign_in: "ログイン", firstname: "名", lastname: "姓", email: "メール", password: "パスワード", company: "会社（任意）",
  comp_intro: "コーチ＆コンパニオンを知る", comp_intro_sub: "任意——あなたを本当に理解するAIコーチのために。",
  situation_ph: "あなたの生活状況（仕事、家族…）", goals_ph: "今の目標", interests_ph: "興味のあること",
  login_submit: "ログイン", secure_pay: "Stripeによる安全な支払い",
  coachdlg_desc: "AIライフコーチ＆相棒を解放：親密で正直な友人が24時間365日そばに。", permonth: "/ 月", activate_coach: "コーチ＆コンパニオンを有効化 — 9.99 €/月",
  ps_checking: "支払いを確認中…", ps_wait_t: "少々お待ちを…", ps_success_life: "生涯アクセスが有効になりました！", ps_success_coach: "コーチ＆コンパニオンが有効に！",
  ps_done: "完了！", ps_oops: "おっと", ps_go_dash: "ダッシュボードへ", ps_notfound: "支払いセッションが見つかりません。", ps_slow: "支払いに時間がかかっています。まもなくダッシュボードをご確認ください。",
  lang_label: "言語", notif_on: "通知をオンにしました 🔔", notif_off: "通知をオフにしました", tz_saved: "タイムゾーンを保存しました",
  hiw_open: "使い方は？",
  hiw_title: "もし一日が早く終わったら？",
  hiw_intro: "GaimTime は時計を速めます。実時間より速く進むので、脳はより早い終業を目指し、前倒しで終えられます。",
  hiw_s1_t: "ゲインを選ぶ", hiw_s1_d: "1時間あたり何分得るかを決めます：5、10、15、20分。",
  hiw_s2_t: "GaimTime時計が加速", hiw_s2_d: "実時間は通常どおり進む一方、GaimTime時計は秒ごとに先行します。",
  hiw_s3_t: "早く終わる", hiw_s3_d: "GaimTime時計が17時を示すとき、実際はまだ16:10。50分を得たことになります。",
  hiw_s4_t: "アラート付きでタスクを計画", hiw_s4_d: "GaimTime時間でタスクをスケジュールし、各ステップで着信音アラートを受け取ります。",
  hiw_example: "例：+10分/時なら、8時間の一日で実時間があと1時間20分残っているのにGaimTimeの一日は「終了」します。この先行が集中力を保ちます。",
  hiw_read: "読む", hiw_listen: "聞く", hiw_loading: "音声を生成中…", hiw_playing: "再生中…",
  offer_clear_t: "明確なオファー。驚きはなし。", offer_clear_sub: "生涯アクセスで必須機能はすべて揃います。コーチはいつでも使える追加オプションです。",
  card1_tag: "生涯アクセス · 一回払い", card2_tag: "プレミアムオプション", card2_optional: "（任意）",
  card2_title: "GaimTime Coach", card2_price: "€9.99", card2_feat: "無制限のパーソナルコーチ", card2_feat2: "モチベーション・意思決定・再集中", card2_note: "ログイン後、あなたのスペースから有効化できます",
  pricing_reassure: "GaimTimeはコーチなしでも100%動作します。コーチは任意で、必須ではありません。",
  listen_msg: "聞く",
  faq_title: "よくある質問",
  faq_q1: "時間は本当に速くなるの？", faq_a1: "いいえ 🙂 これは心理学の原理です。表示される GaimTime 時計が速く進むことで、脳が早く終えようとします。実時間は変わりません。",
  faq_q2: "支払いは一度だけ？", faq_a2: "はい、4.99€ の生涯アクセス、一回払いです。AIコーチは別オプション（9.99€/月）で、強制ではありません。",
  faq_q3: "GaimTime Coach とは？", faq_a3: "あなたを励まし、意思決定を助けるAIパーソナルコーチです。任意で、あなたのスペースから有効化できます。",
  faq_q4: "スマホ / オフラインで使える？", faq_a4: "はい、GaimTime はスマホにインストールできるアプリ（PWA）で、オフラインでも使えます。",
  faq_q5: "私のデータは非公開？", faq_a5: "はい、あなたのデータは非公開で安全に保たれます。支払いは Stripe が処理します。",
  faq_q6: "コーチのサブスクは解約できる？", faq_a6: "はい、いつでも解約できます。GaimTime の生涯アクセスはそのまま残ります。",
  demo_title: "節約できる時間を見てみよう", demo_sub: "1時間あたりに稼ぐ分が多いほど、1日は早く終わります。", demo_classic: "普通の1日", demo_withgaim: "GaimTime を使うと", demo_saved: "{v} の節約 🎉",
  forgot_pw: "パスワードをお忘れですか？", forgot_title: "パスワードをリセット", forgot_desc: "メールアドレスを入力すると、新しいパスワードを設定するリンクを送信します。", forgot_submit: "リンクを送信", forgot_sent: "このメールのアカウントが存在する場合、リセットリンクを送信しました。", back_to_login: "← ログインに戻る",
  reset_title: "新しいパスワード", reset_desc: "アカウントの新しいパスワードを設定してください。", reset_new_pw: "新しいパスワード", reset_confirm_pw: "パスワードを確認", reset_submit: "パスワードを更新", reset_success: "パスワードを更新しました！ログインできます。", reset_mismatch: "パスワードが一致しません。", reset_invalid_link: "リンクが無効か期限切れです。もう一度リクエストしてください。", reset_short: "パスワードは6文字以上必要です。",
  edit_profile: "プロフィールを編集", profile_title: "マイプロフィール", profile_saved: "プロフィールを更新しました", save: "保存", cancel: "キャンセル",
  coach_cfg_btn: "コーチを設定", coach_cfg_title: "コーチ＆コンパニオンを設定", coach_cfg_desc: "すべて任意 — あなたに合うコーチを作りましょう。仕事・人生・その他、いつでも変更できます。",
  cfg_gender: "コーチの性別", cfg_gender_m: "男性", cfg_gender_f: "女性",
  cfg_type: "コーチの専門", type_work: "仕事", type_life: "人生", type_love: "恋愛・人間関係", type_intimate: "親密さ", type_company: "コンパニオン", type_other: "その他",
  cfg_tone: "トーン", tone_direct: "率直で正直", tone_soft: "やさしく思いやり", tone_motiv: "励まし",
  cfg_nickname: "コーチは何と呼べばいい？", cfg_challenges: "今の課題や悩み", cfg_values: "あなたが最も大切にすること", cfg_motivation: "あなたを動かすもの",
  support_btn: "サポート", tickets_title: "サポート＆チャット", tickets_desc: "質問がありますか？メッセージをどうぞ、ここで返信します。", ticket_new: "新しいメッセージ", ticket_subject: "件名", ticket_message: "メッセージ", ticket_send: "送信", ticket_reply_ph: "返信を入力…", ticket_empty: "まだ会話はありません。", ticket_open: "対応中", ticket_closed: "クローズ", ticket_sent: "メッセージを送信しました！", ticket_back: "← 戻る", ticket_you: "あなた", ticket_team: "GaimTime チーム", coach_daily_left: "本日の残りメッセージ",
  coach_limit_title: "本日150メッセージに達しました 👏", coach_limit_desc: "また明日……または今すぐパックで続けましょう。", coach_buy_pack: "続ける · +150メッセージ · 2€", coach_bonus_label: "ボーナス",
  err_generic: "問題が発生しました。もう一度お試しください。",
};

const dict = { en, fr, es, de, it, pt, ru, ar, zh, ja };

function detectLang() {
  try {
    const q = new URLSearchParams(window.location.search).get("lang");
    if (q && dict[q]) return q;
  } catch (e) { /* ignore */ }
  const saved = localStorage.getItem("gaimtime_lang");
  if (saved && dict[saved]) return saved;
  const nav = (navigator.language || "en").slice(0, 2).toLowerCase();
  return dict[nav] ? nav : "en";
}

const I18nContext = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState(detectLang());

  useEffect(() => {
    document.documentElement.lang = lang;
    document.documentElement.dir = RTL_LANGS.includes(lang) ? "rtl" : "ltr";
  }, [lang]);

  const setLang = useCallback((code) => {
    localStorage.setItem("gaimtime_lang", code);
    setLangState(code);
  }, []);

  const t = useCallback((key, vars) => {
    let str = (dict[lang] && dict[lang][key]) ?? dict.en[key] ?? key;
    if (vars) Object.keys(vars).forEach((k) => { str = str.replace(`{${k}}`, vars[k]); });
    return str;
  }, [lang]);

  return <I18nContext.Provider value={{ lang, setLang, t }}>{children}</I18nContext.Provider>;
}

export function useI18n() {
  return useContext(I18nContext);
}
